import React, { Component } from 'react';
import lottie from 'lottie-web';
import Course from '../components/on/Course';
import { COURSE, COURSE_V2, HOMEWORK, COURSE_API } from '../utils/Req';
import { Utils } from '../utils/Utils';
import { Cos } from '../lib/Cos';
import CourseScoreDialog from '../components/dialog/course';
import { CommonDialog } from '../components/dialog/Dialog';
import { WebRTC } from '../utils/WebRTC';
import request from '../lib/request';
import { putaoWS } from '../lib/ws';
import { getParamsObj } from '../lib/InterfaceCalculation';
import $ from 'jquery';

import '../static/css/on.scss';
import utils from '../lib/utils';

lottie.setQuality('low');

window.isDev = Utils.getQueryString('code') && Utils.getHashQueryString('url') ? true : false;

window.localStorage.removeItem('isFatherLessonEnd');

if (window.isDev) {
    const headElement = document.querySelector('head');
    if (headElement) {
        let mateElement;
        //  = document.querySelector("#httpToHttps");
        if (!mateElement) {
            mateElement = document.createElement('meta');
            mateElement.httpEquiv = 'Content-Security-Policy';
            mateElement.content = 'upgrade-insecure-requests';
            // mateElement.id = "httpToHttps";
            headElement.appendChild(mateElement);
        }
    }
}

window.startTime = 0; //发送 /lesson/start，/lesson/finish 用
window.beginTime = parseInt(new Date().getTime() / 1000, 10); //发送 /lesson/situation2 用
window.resourceUrl = ''; //图片资源路径
window.sayNamePrefix = ''; //名字mp3路径
window.reTryTime = 0; //失败重试的次数
window.zIndex = 0; //图片层级控制，防止图片遮挡
window.courseSize = {
    width: 974,
    height: 518,
};
window.mainSize = {
    //显示区的宽高
    width: 690,
    height: 518,
    percent: 1,
};
const videoPlayTimeInterval = 40; //记录课程进度的时间粒子，canvas绘图也已这个时间为准;ms

window.needRecoRecordCourse = !window.isDev && process.env.NODE_ENV !== 'development'; //是否需要演绎回放
window.isRecordingVideo = false; //当期是否处于录屏状态
window.recordPageTime = 0; //每页开始run的时间，用于记录录屏的action时间
window.keyStr = ''; //记录当前节点运行的key路径，用于做录屏上报
window.curPageSceneList = {}; //存放当前页sceneList，录屏上报json用
window.withXunFeiASR = 0; //withXunFeiASR = 1代表使用讯飞，0或者空则不用讯飞

const ua = navigator.userAgent.toLocaleLowerCase();
const isSafari = /safari/.test(ua) && !/chrome/.test(ua);
window.isApp = ua.indexOf('kidslearning_inapp_web') > -1 || ua.indexOf('kidlearning_inapp_web') > -1 || ua.indexOf('kidslearning_vipbingo_web') > -1 ? true : false;
window.canSocket = window.isApp && ua.indexOf('1.0.0') === -1 ? true : false;
window.needFfmpegRecordCourse = false;   // 是否需要Ffmpeg录屏

window.integrals = 0;   // 积分
window.curIntegrals = 0;   // 当前交互获得的积分

window.medalOnOff = true;   // 勋章系统开关。打开是勋章+课程小结，关闭是给星星

class On extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasDevices: (window.isDev && window.location.protocol === 'http:') ? true : false, //是否获取了摄像头、麦克风权限   process.env.NODE_ENV === 'development' ? true :
            hasResult: false, //是否获取到数据
            isPause: true,
            pauseButton: 0,
            showDeviceTips: false, //设备禁用弹窗
            expandCourse: false, //是否进来就全屏
            toCenter: 0, //1-拉全屏; 2-取消全屏
            currStarCount: 0, //当前的星星数
            currSubjectCount: 0, //当前题目数（有starSubject=1的时候就加1）
            complete: false, //上完所有课
            isBack: false, //点击返回
            hideDialog: false,  //隐藏是否继续学习弹窗，true是继续测试
            localStorageInfo: window.localStorage.getItem('exitLesson-' + Utils.getHashQueryString('cid'))
                ? JSON.parse(window.localStorage.getItem('exitLesson-' + Utils.getHashQueryString('cid')))
                : null, //有缓存的学习记录

            totalPage: 0, //总共页数
            curPage: Utils.getHashQueryString('page') ? Utils.getHashQueryString('page') : '0', //当前第几页

            queue: null, //存放父节点关系树
            actions: null, //存放父节点actions
            showPageNodes: [], //存放当前需要渲染的节点列表
            curRunNodeNum: '0', //当前渲染的节点序号

            childQueue: null, //存放子节点关系树
            childActions: null, //存放子节点actions
            showChildPageNodes: [], //存放当前子timeline需要渲染的节点列表
            curRunChildIndex: 0, //当前渲染到第几个子节点集合--一个页面会有多个ChildNode
            curRunChildNodeNum: '0', //当前渲染的子节点序号
            curRunChildNodeParent: null, //当前渲染的子节点的父节点，因为有子节点下还有渲染timeline的情况

            playingVideo: {
                url: '',
                isChild: false,
                isPlaying: false, //是否正在播放中
                nodeNum: -1, //当前视频所属的节点编号
            },
            showNoNetWorkDialog: false, //显示卡顿10s后视频加载失败弹窗
            videoDownloadProgress: 0, //课程视频的下载进度，0~100
            videoDownloadLocalUrl: "",   //存放视频列表cid的本的本地url

            doneTryData: null, //存放done模板的数据

            isCourseTeacherExchange: false, //是否课件区和老师区视频互换
            isToCocoOrPc: false, //判断是去coco还是pc学习。true-pc学习
            noNeedCommit: false, // 不需要评论框

            showDeniedRecordTips: false, //不能录屏弹窗
        };
        this.courseInfo = null;
        this.courseTitle = '';
        this.version = '';
        this.intervalCanvasImg = null;
        this.cid = Utils.getHashQueryString("cid");
        this.project = Utils.getHashQueryString("project") || "";
        this.putaoid = Utils.getCookie("putaoid");
        this.token = encodeURIComponent(Utils.getCookie("token"));
        this.uuid = Utils.getCookie("uuid");
        this.isCamp = /^300_/.test(Utils.getHashQueryString('cid'));    //是否是体验营
        this.isReaders = /_100$/.test(Utils.getHashQueryString('cid'));    //是否是阅读课，2.0以后阅读课不请求 minor/readers 也请求 /lesson/lesson/ 所以只能通过这个来区分
        this.isCTlesson = Utils.getHashQueryString("url") ? true : false; //是否是中教课，也支持其他从url传的一个地址
        this.isTrialLesson = (Utils.getHashQueryString("cid") && Utils.getHashQueryString("cid").indexOf('_100_') > -1) ? true : false; //是否是体验课
        this.isUrlLesson = Utils.getHashQueryString("lessonType") ? decodeURIComponent(Utils.getHashQueryString("lessonType")) : false;
        this.isFatherLesson = (Utils.getHashQueryString("cid") && Utils.getHashQueryString("cid").indexOf('300_1_0') > -1) ? true : false; //父亲节的课，上完了存个值，方便在父亲节活动弹窗
        this.noHomework = Utils.getHashQueryString("nohome") ? parseInt(Utils.getHashQueryString("nohome")) : false; //没有作业：1-看报告；2-待定
        this.homeworkurl = utils.getQueryString("homeworkurl") && utils.getQueryString("homeworkurl").length > 10 ? decodeURIComponent(utils.getQueryString("homeworkurl")) : "";
        this.videoPlayTime = 0; //课程进行的时间进度，已视频播放时间进度为参考
        this.sceneList = []; //存放sceneList，录屏上报json用
        this.nextPageImgArr = []; //存放预加载下一页的图片
        this.needback = Utils.getHashQueryString('needback') ? parseInt(Utils.getHashQueryString('needback')) : false; //需要返回到前面页面
        this.isCanvasLastVideoPic = window.isApp ? false : true; //是否只绘制视频最后一帧。在客户端绘制最后一帧会白屏一下，后续查一下
        this.isVideoCarton = false; //视频是否卡顿中
        this.videoCartonTimer = null; //视频是否卡顿中时间器
        this.videoCartonTotalTimes = 0; //视频卡顿中总时长
        this.duration = 0;  //学习时长。单位s
        this.vipSkipVideoTime = false;  // vip外教第一页第一个视频不播前6s
        this.noCamera = parseInt(utils.getQueryString('code'), 10) === 2 || parseInt(window.localStorage.getItem("code"), 10) === 2 ? true : false;   // 为了配合第三方在电视设备上演示，没有摄像头
        this.localDomain = "http://127.0.0.1:23080";   //播放本地视频的host
        this.cresDomain = /(https:\/\/courses-1256571289.cos.ap-beijing.myqcloud.com)|(https:\/\/cres.putaoabc.com)/;

        this.changeCoursePercent = 1;
        this.changeTeacherPercent = 1;
        this.changeCourseLeft = 0;
        this.teacherWidth = 0;
        this.contentWidth = 0;

        this.medalArray = [
            { "medalId": 201, "medalName": "一鸣惊人", "isGet": false },
            { "medalId": 202, "medalName": "小菜一碟", "isGet": false },
            { "medalId": 203, "medalName": "眼疾手快", "isGet": false },
            { "medalId": 204, "medalName": "不同凡响", "isGet": false },
            { "medalId": 205, "medalName": "出类拔萃", "isGet": false },
            { "medalId": 206, "medalName": "一举成名", "isGet": false }
        ];
        this.isFfmpegRecording = false; //是否正在进行录制
        this.useReplay = 1; // 0-录屏；1-演绎
    }

    componentWillMount() {
        const that = this;
        putaoWS.getCidDownloadProgress(that.cid, (data) => {
            that.setState({
                videoDownloadProgress: data.progress,
                videoDownloadLocalUrl: encodeURIComponent(data.url)
            })
            console.log('该课视频已下载进度: ' + data.progress);
        });
        // 老课还是走演绎，先不走录屏
        // putaoWS.getOsInfo((content) => {
        //     console.log('===getOsInfo===', content)
        //     window.needFfmpegRecordCourse = content.showCloseClient;
        //     window.needRecoRecordCourse = !content.showCloseClient;
        // });
        // window.needFfmpegRecordCourse = true;
        // window.needRecoRecordCourse = false;
    }

    componentDidMount() {
        const that = this;
        const { hasDevices } = this.state;

        //获取授权
        if (!hasDevices) {
            WebRTC.getAuthorization({
                video: true,
                audio: true
            }, () => {  //成功获取摄像头和麦克风
                that.hasDeviceResult();
            }, () => {  //失败
                WebRTC.getAuthorization({
                    audio: true
                }, () => {  //成功获取麦克风
                    that.hasDeviceResult();
                    const webcam = document.getElementById("webcam");
                    if (webcam) {
                        webcam.style.cssText = `background: url("https://webres.putaoabc.com/course/images/common/no-camera.png") center 0 no-repeat;background-size:cover`;
                    }
                    utils.showTips("没有检测到摄像头！", 3000);
                }, () => {  //都失败
                    if (that.noCamera) { // 演示版支持摄像头和麦克风都没有
                        that.hasDeviceResult();
                        utils.showTips("没有检测到摄像头和麦克风！", 3000);
                    } else {
                        that.setState({
                            showDeviceTips: true,
                            hasDevices: false,
                        }, () => {
                            if (window.isApp) {
                                window.localStorage.removeItem('isTest');
                            }
                        });
                    }
                });
            });
        } else {
            that.setState({
                isToCocoOrPc: true
            }, () => {
                that.restartLesson();
                that.reSizeCursor();
            });
        }

        that.drawTeacherImage();

        window.onresize = () => {
            that.reSizeCursor();
        };

        let $content_course = $('#content');
        let $teacher_video = $('#teacherVideoContent');
        let $content_w = $content_course.width();
        let $teacher_w = $teacher_video.width();
        that.contentWidth = $content_w;
        that.teacherWidth = $teacher_w;
        that.changeCourseLeft = parseInt($content_course.css('left'));
        that.changeCoursePercent = $teacher_w / $content_w;
        that.changeTeacherPercent = $content_w / $teacher_w;

        // window.onbeforeunload = function (e) {
        //     let e = window.event || e;
        //     e.returnValue = ("确定离开当前页面吗？");
        // }

        if (!window.isDev) {
            // 预览不需要加载动画
            let teacherLodding = document.getElementById('teacherLodding');
            //老师loading动画
            if (teacherLodding) {
                let teacherLoddingAmi = lottie.loadAnimation({
                    container: teacherLodding,
                    renderer: 'svg',
                    loop: true,
                    autoplay: true,
                    path: window.animationUrl + 'teacher_loading.json',
                });
                teacherLoddingAmi.setSubframe(false);
            }
        }

        // window.onerror = function () {
        //     console.log('===error:', that.state.curPage)
        // }
    }

    componentDidUpdate(prevProps, prevState) {
        const that = this;
        const { curPage, curRunNodeNum, curRunChildNodeNum } = this.state;
        if (curPage > 0 && curPage !== prevState.curPage) {
            that.changePage(curPage);
        }
        //有timeout的时候，后面运行的node节点序号可能小于运行完的 curRunNodeNum < prevState.curRunNodeNum
        if (curRunNodeNum > 0 && curRunNodeNum !== prevState.curRunNodeNum /*&& parseInt(curRunNodeNum) > parseInt(prevState.curRunNodeNum)*/) {
            that.runCurAction(false);
        }
        if (curRunChildNodeNum > 0 && curRunChildNodeNum !== prevState.curRunChildNodeNum) {
            that.runCurAction(true);
        }
    }

    componentWillUnmount() {
        clearInterval(this.intervalCanvasImg);
        clearInterval(this.durationTimer);
        this.setState({
            queue: null,
            actions: null,
            showPageNodes: null,
            childQueue: null,
            childActions: null,
            showChildPageNodes: null,
            doneTryData: null,
        });
        WebRTC.getAuthorization(false);
    }

    hasDeviceResult() {
        const that = this;
        const { curPage, localStorageInfo } = this.state;
        that.setState({
            hasDevices: true
        }, () => {
            //获取授权 && 数据返回
            that.toCocoOrPc(() => {
                that.setState({
                    isToCocoOrPc: true
                }, () => {
                    if (!(
                        (curPage < 1 || (window.isDev && that.cid)) &&  // 外部试课需要记录上到第几页
                        localStorageInfo && localStorageInfo.curPage && localStorageInfo.currStarCount > -1 && localStorageInfo.currSubjectCount > -1 && localStorageInfo.startTime
                    )) {
                        that.restartLesson();
                    } else if (that.project === "vipbingo") {
                        that.continueLocalLesson();
                    }
                    that.reSizeCursor();
                });
            });

            // 处理app里面，学习获取授权成功，就隐藏掉首页的设备检测页卡
            if (window.isApp) {
                window.localStorage.setItem('isTest', true);
            }
        });
    }

    reSizeCursor() {
        const that = this;
        const screenWidth = window.innerWidth || window.screen.availWidth;
        const screenHeight = window.innerHeight || window.screen.availHeight;
        let useWidth = screenWidth - 40;
        let useHeight = screenHeight - 130;
        const root = document.getElementById('root');
        const cursor = document.getElementById('cursor');
        const content = document.getElementById('content');
        const teacherVideoContent = document.getElementById('teacherVideoContent');
        const studyVideoContent = document.getElementById('studyVideoContent');
        const playPauseBtn = document.getElementById('playPauseBtn');

        let rootClass = root.className;
        if (!(screenWidth > 974 && screenHeight > 588)) {
            useWidth = screenWidth;
            useHeight = screenHeight - 40;
            if (rootClass.indexOf('innerPhone') === -1) {
                root.className += " innerPhone";
            }
        } else {
            if (rootClass.indexOf('innerPhone') > -1) {
                root.className = root.className.replace(" innerPhone", "");
            }
        }

        if (useWidth / useHeight > window.courseSize.width / window.courseSize.height) {
            window.courseSize.width = (useHeight * window.courseSize.width) / window.courseSize.height;
            window.courseSize.height = useHeight;
        } else {
            window.courseSize.height = (useWidth * window.courseSize.height) / window.courseSize.width;
            window.courseSize.width = useWidth;
        }
        window.mainSize.width = (window.courseSize.height * window.mainSize.width) / window.mainSize.height;
        window.mainSize.height = window.courseSize.height;
        window.mainSize.percent = window.mainSize.height / 518;
        root.style.width = '100%';

        if (cursor) {
            cursor.style.width = window.courseSize.width + 'px';
            cursor.style.height = window.courseSize.height + 'px';
            cursor.style.marginTop = -(window.courseSize.height / 2 - 30) + 'px';
            cursor.style.marginLeft = -(window.courseSize.width / 2) + 'px';
        }
        if (content) {
            content.style.width = window.mainSize.width + 'px';
            content.style.height = window.mainSize.height + 'px';
            content.style.left = that.state.isCourseTeacherExchange ? 0 : 284 * window.mainSize.percent + 'px';
        }

        if (teacherVideoContent) {
            teacherVideoContent.style.width = 259 * window.mainSize.percent + 'px';
            teacherVideoContent.style.height = 194 * window.mainSize.percent + 'px';
        }
        if (studyVideoContent) {
            studyVideoContent.style.width = 259 * window.mainSize.percent + 'px';
            studyVideoContent.style.height = 194 * window.mainSize.percent + 'px';
            studyVideoContent.style.top = window.mainSize.height * 0.06 + 214 * window.mainSize.percent + 'px'; //214是老师窗口高度加上空隙
        }
        if (playPauseBtn) {
            playPauseBtn.style.transform = `scale(${window.mainSize.percent})`;
            playPauseBtn.style.transformOrigin = 'left top 0px';
            playPauseBtn.style.top = studyVideoContent.offsetTop + 204 * window.mainSize.percent + 'px';

            playPauseBtn.style.left = 159 * window.mainSize.percent / 2 + 'px';
        }

        //这里只是为了resize以后能够重新render
        that.setState({
            totalPage: that.state.totalPage,
        });

        // that.contentWidth = $content_w;
        // that.teacherWidth = $teacher_w;
        let $study_video = $('#studyVideoContent');
        let $teacher_video = $('#teacherVideoContent');
        let $teacher_w = $study_video.width();
        let $content_w = (parseInt($teacher_w) * 690) / 259;
        that.changeCoursePercent = $teacher_w / $content_w;
        that.changeTeacherPercent = $content_w / $teacher_w;
        // if (content.className.indexOf("fullScreen") > -1 || content.className.indexOf("toCentent") > -1) {
        //     that.changeCourseLeft = 284 * window.mainSize.percent + "px";
        // } else {
        //     that.changeCourseLeft = (parseInt(that.teacherWidth) + 25) * window.mainSize.percent;
        // }
        // that.changeCourseLeft = (parseInt($teacher_w) + 25) * window.mainSize.percent;
        that.changeCourseLeft = 284 * window.mainSize.percent;
        if (that.state.isCourseTeacherExchange) {
            teacherVideoContent.style.left = (parseInt($teacher_w) + 25) * that.changeCoursePercent + 'px';
        }
    }

    // 初始化勋章的状态
    getMedalList() {
        const that = this;
        const paramsStr = getParamsObj();
        const url = `${COURSE_API.encourage_pre_record}?${Utils.setJsonToUrl(paramsStr)}`;
        request(url, {
            "cid": that.cid,
            "putaoid": parseInt(that.putaoid),
            "startTime": window.startTime,
            "lastPage": parseInt(that.state.curPage, 10) + 1
        }, {
            "method": "GET"
        }, 15000).then(function (response) {
            return response.json();
        }).then((json) => {
            let medalInfos;
            if (json && json.code === 200 && json.data && json.data.medalInfos && json.data.medalInfos instanceof Array) {
                // 成功
                medalInfos = json.data.medalInfos;
                window.integrals = json.data.integrals;
                const integrals_num = document.getElementById("integrals_num");
                if (integrals_num) {
                    integrals_num.innerText = window.integrals;
                }
            } else if (json && json.code === 499) {
                // utils.appLogin((newUserInfo) => {
                //     that.user = newUserInfo;
                //     that.submitWordIntegrals();
                // });
            } else {
                try {
                    window.PTMonitor.report({
                        type: 'apiSucEx',
                        url: window.location.href,
                        putaoid: that.putaoid,
                        info: json,
                        stack: url
                    }, window.EX_TYPE.apiSucEx);
                } catch (err) { }
            }
            that.genMedalList(medalInfos);
        }).catch(err => {
            that.genMedalList();
            try {
                window.PTMonitor.report({
                    type: 'apiEx',
                    url: window.location.href,
                    putaoid: that.putaoid,
                    stack: url,
                    info: err
                }, window.EX_TYPE.apiEx);
            } catch (err) { }
        });
    }

    genMedalList(medalInfos) {
        const that = this;
        const medalList = document.getElementById("medalList");
        const integrals = document.getElementById("integrals");
        let medalHtml = "";
        for (let i = 0; i < that.medalArray.length; i++) {
            let medalItem = that.medalArray[i];
            if (medalInfos && medalInfos.length) {
                let hasMedals = Utils.getItemKeyInArrayObject(medalInfos, medalItem.medalId, "medalId");
                if (typeof hasMedals !== "undefined") {
                    medalItem.isGet = true;
                }
            }
            medalHtml += `<li id="medal_${medalItem.medalId}" class="${medalItem.isGet ? 'give' : 'gray'}"><img src="https://webres.putaoabc.com/course/images/medal/medal-${medalItem.medalId}_s80.png" title="${medalItem.medalName}" /></li>`
        }
        medalList && (medalList.innerHTML = medalHtml);
        integrals && (integrals.style.display = "block");
    }

    // 判断是去coco还是pc学习
    toCocoOrPc(callback) {
        const that = this;
        const paramsStr = getParamsObj();
        let url = COURSE_V2 + `/lesson/lesson?cid=${that.cid}&${Utils.setJsonToUrl(paramsStr)}`;
        if (that.isUrlLesson) {
            url = COURSE + `/${that.isUrlLesson}/lesson?putaoid=${that.putaoid}&token=${that.token}&cid=${that.cid}&from=pc`;
        } else if (that.isCTlesson) {
            url = decodeURIComponent(Utils.getHashQueryString('url'));
            url += `${url.indexOf('?') > -1 ? '&' : '?'}cid=${that.cid}&${Utils.setJsonToUrl(paramsStr)}`;
            if (window.isDev) {
                url = url.replace('putaoabc-inc.com', 'course.putaoabc.net.cn').replace('inner.putaoabc.net.cn:5002', 'course.putaoabc.net.cn');
            }
        }

        fetch(
            new Request(url, {
                method: 'GET',
            })
        )
            .then(function (response) {
                return response.json();
            })
            .then(function (res) {
                if (
                    (res && res.code === 200 && res.lesson && res.lesson.jsonUrl) ||
                    (window.isDev && res.courseList && res.courseList instanceof Array && res.courseList.length)
                ) {
                    let lesson = window.isDev ? res.courseList[0] : res.lesson;
                    // window.withXunFeiASR = lesson.withXunFeiASR || 0;
                    if (lesson.coursewareType && lesson.coursewareType === "cocos") {
                        that.getKidName(function () {   //game2 是cocos星星课， game 是勋章课
                            that.cocosOnUrl(window.ffmpegDeniedRecord);
                        });
                    } else {
                        callback();
                    }
                } else if (res && res.code === 499 && !window.isDev) {
                    if (that.project === "vipbingo") {
                        window.location.href = "https://www.aibingo.com.cn/bingo/vip_course/#/login?url=" + encodeURIComponent(window.location.href);
                    } else {
                        window.location.href = `${window.location.pathname}${window.location.search}#/login?url=${encodeURIComponent(window.location.href)}`;
                    }
                } else if (res && parseInt(res.code, 10) === 461) {
                    utils.showTips("没有学习权限。", 3000, () => {
                        window.history.back();
                    });
                } else {
                    utils.showTips(res.msg || "服务异常！", 3000, () => {
                        window.history.back();
                    });
                }
            });
    }

    getCourseData(callback) {
        const that = this;
        const paramsStr = getParamsObj();
        let url = COURSE_V2 + `/lesson/lesson?cid=${that.cid}&${Utils.setJsonToUrl(paramsStr)}`;

        // let url = COURSE + `${that.isTrialLesson ? "/trial" : ""}/lesson/lesson?putaoid=${that.putaoid}&token=${that.token}&cid=${that.cid}&from=pc`;
        if (that.isUrlLesson) {
            url = (that.project === "vipbingo" ? COURSE_V2 : COURSE) + `/${that.isUrlLesson}/lesson?cid=${that.cid}&${Utils.setJsonToUrl(paramsStr)}`;
        } else if (that.isCTlesson) {
            url = decodeURIComponent(Utils.getHashQueryString('url'));
            url += `${url.indexOf('?') > -1 ? '&' : '?'}cid=${that.cid}&${Utils.setJsonToUrl(paramsStr)}`;
            if (window.isDev) {
                root.className += " innerCode";
                url = url.replace('putaoabc-inc.com', 'course.putaoabc.net.cn').replace('inner.putaoabc.net.cn:5002', 'course.putaoabc.net.cn');
            }
        }

        fetch(
            new Request(url, {
                method: 'GET'
            })
        )
            .then(function (response) {
                return response.json();
            })
            .then(function (res) {
                if (
                    (res && res.code === 200 && res.lesson && res.lesson.jsonUrl) ||
                    (window.isDev && res.courseList && res.courseList instanceof Array && res.courseList.length)
                ) {
                    let lesson = window.isDev ? res.courseList[0] : res.lesson;
                    if (lesson.coursewareType && lesson.coursewareType === "cocos") {
                        that.cocosOnUrl(window.ffmpegDeniedRecord);
                    } else {
                        that.courseTitle = lesson.headText || lesson.title || '';
                        that.version = lesson.version || '';

                        let jsonUrl = lesson.jsonUrl;
                        if (jsonUrl.indexOf('http://') > -1) {
                            jsonUrl = jsonUrl.replace('http://', 'https://');
                        }
                        if (window.isDev) {
                            jsonUrl = jsonUrl.replace('putaoabc-inc.com', 'course.putaoabc.net.cn').replace('inner.putaoabc.net.cn:5002', 'course.putaoabc.net.cn');
                        }

                        fetch(new Request(jsonUrl + '?from=pc&v=' + lesson.resourceVersion, { method: 'GET' }))
                            .then(function (response) {
                                return response.json();
                            })
                            .then(function (json) {
                                if (json && json.sceneList && json.sceneList.length) {
                                    that.courseInfo = json.courseInfo;
                                    window.resourceUrl = json.courseInfo.webPrefix;
                                    window.sayNamePrefix = json.courseInfo.sayNamePrefix;
                                    let webPrefix = json.courseInfo.webPrefix;
                                    that.getKidName(); //加载数据就开始准备，防止播放的时候下载导致声音对不上

                                    if (window.isDev) {
                                        window.resourceUrl = window.resourceUrl
                                            .replace('putaoabc-inc.com', 'course.putaoabc.net.cn')
                                            .replace('inner.putaoabc.net.cn:5002', 'course.putaoabc.net.cn');
                                        webPrefix = webPrefix
                                            .replace('putaoabc-inc.com', 'course.putaoabc.net.cn')
                                            .replace('inner.putaoabc.net.cn:5002', 'course.putaoabc.net.cn');
                                    }

                                    //加载js
                                    Utils.loadJs(webPrefix + 'Interaction_Info.js?v=' + lesson.resourceVersion, () => {
                                        that.formatSceneList(json.sceneList);
                                        that.setState({
                                            hasResult: true,
                                        }, () => {
                                            //获取授权 && 数据返回
                                            if (that.state.hasDevices) {
                                                callback();

                                                that.sceneList = json.sceneList;

                                                //上传回放的 course.json 到cos
                                                if (window.needRecoRecordCourse) {
                                                    json.sceneList = [];
                                                    json.reportBy = 'pc';
                                                    json.replayModel = 1; //录制了学生区环境音
                                                    json.courseTitle = lesson.title;
                                                    json.courseBeginTime = Utils.formatDate('yyyy-MM-dd hh:mm:ss');
                                                    Cos.uploadVideoToCos(null, {
                                                        cid: Utils.getHashQueryString('cid'),
                                                        putaoid: Utils.getCookie('putaoid'),
                                                        startTime: window.startTime,
                                                        curPage: 'course',
                                                        result: JSON.stringify(json),
                                                    });
                                                }
                                            }
                                        });
                                    });
                                }
                            })
                            .catch(() => {
                                if (that.project === "vipbingo") {
                                    window.location.href = "https://www.aibingo.com.cn/bingo/vip_course/#/login?url=" + encodeURIComponent(window.location.href);
                                } else {
                                    window.location.href = `${window.location.pathname}${window.location.search}#/login?url=${encodeURIComponent(window.location.href)}`;
                                }
                            });
                    }
                } else if (res.code === 499 && !window.isDev) {
                    if (that.project === "vipbingo") {
                        window.location.href = "https://www.aibingo.com.cn/bingo/vip_course/#/login?url=" + encodeURIComponent(window.location.href);
                    } else {
                        window.location.href = `${window.location.pathname}${window.location.search}#/login?url=${encodeURIComponent(window.location.href)}`;
                    }
                } else if (!window.isDev) {
                    if (that.project === "vipbingo") {
                        window.location.href = `https://www.aibingo.com.cn/bingo/vip_course/#/experience_camp?v=${window.pt_vid}`;
                    } else {
                        window.location.href = `${window.location.pathname}${window.location.search}#/path`;
                    }
                }
            });
    }

    cocosOnUrl(deniedRecord) {
        const that = this;
        const { videoDownloadProgress, videoDownloadLocalUrl, curPage } = this.state;
        const paramsStr = getParamsObj();
        const sereenRecordneverNotify = window.localStorage.getItem('sereenRecordneverNotify');
        if (deniedRecord && !(sereenRecordneverNotify && sereenRecordneverNotify === "1")) {
            that.setState({
                showDeniedRecordTips: true
            })
        } else {
            window.location.replace(`game/?cid=${that.cid}${curPage ? '&page=' + curPage : ''}&project=${that.project}${that.homeworkurl ? ("&homeworkurl=" + encodeURIComponent(that.homeworkurl)) : ""}${that.noCamera ? "&istv=1" : ""}&progress=${videoDownloadProgress}&videolist=${videoDownloadLocalUrl}&ts=${paramsStr.ts}&sign=${paramsStr.sign}&v=${Math.floor(Math.random() * 10000)}`);
        }
    }

    getKidName(callback) {
        const that = this;

        fetch(
            new Request(`${COURSE_API.user}?putaoid=${that.putaoid}&token=${that.token}&cid=${that.cid}&from=pc`, {
                method: 'GET',
            })
        )
            .then(function (response) {
                return response.json();
            })
            .then(function (res) {
                if (res && res.code === 200) {
                    if (res.eng_name && res.eng_name.length) {
                        const sayName = document.getElementById('sayName');
                        window.localStorage.setItem('kidName', res.eng_name);
                        if (sayName && window.sayNamePrefix) {
                            sayName.setAttribute('src', `${window.sayNamePrefix}${res.eng_name.toLocaleLowerCase()}.mp3`);
                            //如果加载失败，读默认的 kid.mp3
                            sayName.addEventListener('error', () => {
                                sayName.setAttribute('src', `${window.sayNamePrefix}kid.mp3`);
                            });
                        }
                    }
                    //是否显示暂停按钮
                    that.setState({
                        pauseButton: res.pauseButton || 0,
                    }, () => {
                        if (typeof res.pauseButton === 'number') {
                            window.localStorage.setItem('pauseButton', res.pauseButton);
                        }
                        if (callback && typeof callback === 'function') {
                            callback();
                        }
                    });
                } else if (res && res.code === 499 && !window.isDev) {
                    if (that.project === "vipbingo") {
                        window.location.href = "https://www.aibingo.com.cn/bingo/vip_course/#/login?url=" + encodeURIComponent(window.location.href);
                    } else {
                        window.location.href = `${window.location.pathname}${window.location.search}#/login?url=${encodeURIComponent(window.location.href)}`;
                    }
                }
            });
    }

    /**
     *
     * @param {Array} sceneList 需要格式化的元素list
     * @param {boolean} hasChildTimeline 是否是处理儿子的timeline
     * @param {object} returnScore 当timeline=true时，returnScore是原始数据
     */
    formatSceneList(sceneList, hasChildTimeline, returnScore) {
        const that = this;
        let queue = {};
        let actions = {};
        sceneList.forEach((item, index) => {
            let timeline = item.timeline;
            let links = timeline.links;
            let nodes = timeline.nodes;
            let maxTimes = 0;
            if (!queue[index]) {
                queue[index] = {};
            }

            //遍历 nodes
            nodes.forEach(node => {
                if (!actions[index]) {
                    actions[index] = {};
                }
                if (!actions[index][node.actionsID]) {
                    actions[index][node.actionsID] = {};
                }
                actions[index][node.actionsID] = node.actions;

                //提取视频的时间，暂时只处理子类的
                if (hasChildTimeline) {
                    let nodeActions = node.actions;
                    for (let j = 0; j < nodeActions.length; j++) {
                        let nodeActionsItem = nodeActions[j];
                        if (nodeActionsItem && nodeActionsItem.actionType === 'PlayVideo_' && nodeActionsItem.detail && nodeActionsItem.detail.length) {
                            maxTimes = nodeActionsItem.detail.length * 1000;
                        }
                    }
                }
            });

            //遍历 links
            links.forEach(link => {
                let source = link.source;
                let target = link.target;
                let delay = link.delay;
                if (hasChildTimeline && delay > maxTimes) {
                    delay = maxTimes;
                }
                if (!queue[index][source]) {
                    queue[index][source] = {};
                }
                if (!queue[index][target]) {
                    queue[index][target] = {};
                }

                //确认子节点
                if (!queue[index][source]['sonNodes']) {
                    queue[index][source]['sonNodes'] = [];
                }
                if (!queue[index][source]['sonNodes'].includes(target)) {
                    queue[index][source]['sonNodes'].push(target);
                }
                queue[index][source]['isFinished'] = 0;

                //确认父节点
                if (!queue[index][target]['fatherNodes']) {
                    queue[index][target]['fatherNodes'] = [];
                }
                if (target > 0 && !queue[index][target]['fatherNodes'].includes(source)) {
                    queue[index][target]['fatherNodes'].push(source);
                }

                //确认子节点延迟
                if (!queue[index][source]['sonDelay']) {
                    queue[index][source]['sonDelay'] = [];
                }
                if (target > 0) {
                    queue[index][source]['sonDelay'].push(delay);
                    queue[index][target]['delay'] = delay;
                }
            });
        });
        // console.log('queue:', queue);
        // console.log('actions:', actions);
        if (hasChildTimeline) {
            that.updateChildQueueAndActions(queue, actions, returnScore);
        } else {
            that.updateQueueAndActions(queue, actions, sceneList.length);
        }
    }

    updateQueueAndActions(queue, actions, sceneListLen) {
        const that = this;
        that.setState({
            totalPage: sceneListLen,
            queue: queue,
            actions: actions,
        }, () => {
            !that.state.hideDialog && that.changePage();    // 前面的判断是为了处理继续测试的时候不用渲染第一页
        });
    }

    updateChildQueueAndActions(queue, actions, returnScore) {
        const that = this;
        that.setState({
            childQueue: queue,
            childActions: actions,
            curRunChildNodeParent: returnScore ? returnScore : that.state.actions[that.state.curPage][that.state.curRunNodeNum][0], //当前渲染的子节点的父节点，因为有子节点下还有渲染timeline的情况
            // showChildPageNodes: [],  //存放当前子timeline需要渲染的节点列表
            // curRunChildNodeNum: "0", //当前渲染的子节点序号

            showChildPageNodes: that.state.showChildPageNodes.length ? that.state.showChildPageNodes : [], //存放当前子timeline需要渲染的节点列表
            curRunChildNodeNum: '0', //当前渲染的子节点序号
            curRunChildIndex: that.state.showChildPageNodes.length ? that.state.curRunChildIndex + 1 : 0,
        }, () => {
            that.runCurAction(true, that.state.curPage, '0');
        });
    }

    changePage(page) {
        const that = this;
        const { currStarCount, currSubjectCount } = this.state;
        that.setLocalStorage();
        page = page || that.state.curPage;
        window.zIndex = 0; //重置层级
        window.curPageToReport = page || 0;
        window.actionID = "";   // 因为不通过的页actionID可能相同，因此翻页的时候清空
        if (page) {
            that.setState({
                curPage: page,
                curRunNodeNum: '0',
                showPageNodes: [],
                expandCourse: false,

                childQueue: null,
                childActions: null,
                curRunChildNodeNum: '0',
                showChildPageNodes: [],
                curRunChildIndex: 0,

                playingVideo: {
                    url: that.state.playingVideo.url || '',
                    isChild: false,
                    isPlaying: false,
                    nodeNum: -1,
                },
                doneTryData: null,  // 修复上一页的showAnswer带入到下一个交互
                // isCourseTeacherExchange: false,  // 为了修复上一页老师和学生切换后，切换到下一页是全屏游戏，不会拉回去
            }, () => {
                that.runCurAction(false, page);
            });
            // lottie.destroy();

            //录制视频、replace后的json上传到cos
            if (window.needRecoRecordCourse) {
                let getStudyVideo = WebRTC.getRecordVideoBlob();
                if (getStudyVideo && that.sceneList[page - 1]) {
                    let curSceneList = that.sceneList[page - 1];
                    if (curSceneList) {
                        curSceneList.currentStarCount = currStarCount;
                    }
                    if (curSceneList) {
                        curSceneList.starSubjectCount = currSubjectCount;
                    }
                    Cos.uploadVideoToCos(getStudyVideo, {
                        cid: that.cid,
                        putaoid: Utils.getCookie('putaoid'),
                        startTime: window.startTime,
                        curPage: page - 1,
                        result: JSON.stringify(curSceneList),
                    });
                    WebRTC.stopRecordVideo(() => {
                        // setTimeout(() => {
                        //     WebRTC.startRecordVideo();
                        // }, 100);
                    });

                    window.keyStr = '';
                    // console.log(curSceneList);
                }
            }
        } else {
            that.runCurAction(false, page);
        }

        if (window.needFfmpegRecordCourse) {
            putaoWS.startRecordScreen({
                cosPath: `pc/${that.cid}/${that.putaoid}/${window.startTime}/video/${page}`,
                start: 1
            });
            that.isFfmpegRecording = true;
        }

        // 进到倒数第二页就发gen_report
        if (parseInt(page, 10) === that.state.totalPage - 2) {
            that.finishSendLessonStat(true);
        }

        //预加载下一页图片
        if (parseInt(page, 10) < that.state.totalPage - 1) {
            setTimeout(() => {
                that.reloadNextPageImg();
            }, 3000);
        }

        //圈图成功后，保留圆圈，在翻页后需要去掉
        that.cleanCircle();
    }

    cleanCircle() {
        try {
            let drawCircle = document.getElementById('drawCircle');
            // if (drawCircle) {
            //     document.getElementById('content_course').removeChild(drawCircle);
            // }
            if (drawCircle && drawCircle.parentNode) {
                drawCircle.parentNode.removeChild(drawCircle);
            }
        } catch (error) { }
    }

    //渲染当前子节点，actions 下 detail 是 timeline 的情况
    /**
     * 渲染当前节点
     * 1、先获取当前页（page）的 curRunMap 关系树，结构如下
     *   {"0":{"sonNodes":["1"],"delay":[0]},"1":{"fatherNodes":["0"],"delay":[0],"sonNodes":["2"]},"2":{"fatherNodes":["1"],"delay":[0],"sonNodes":["3"]},"3":{"fatherNodes":["2"],"delay":0}}
     * 2、curNum，是当前关系树正在运行的 key；curActions 是存放当前 key 对应的需要渲染的 nodes 的 array
     *    1、运行 curActions[curNum]
     *    2、若 array 中有数据，则开始运行，把节点的list拼接到需要渲染的 showPageNodes 中，进行render
     *    3、若为 [] 空数组，则查找当前运行节点下的 sonNodes 里面是否有子节点，若有调用 getSonNodes 方法解析
     */
    runCurAction(isChild, page, curNum) {
        const that = this;
        const { currStarCount, currSubjectCount, videoDownloadProgress } = this.state;
        let _page = page || that.state.curPage;
        let curRunMap = that.state.queue[_page] || {};
        let curActions = that.state.actions[_page] || {};

        let _curNum = isChild ? curNum || that.state.curRunChildNodeNum : curNum || that.state.curRunNodeNum;
        // let _curChildNum = curChildNum || that.state.curRunChildNodeNum;

        if (isChild) {
            if (!that.state.childQueue || !that.state.childActions) return;
        }

        //注意：假如 actions 下 detail 的 timeline 的数组大于1, 这里就需要修改，不能用 [0]，目前是{}
        let curRunNodeQueue = isChild ? that.state.childQueue[0][_curNum] : curRunMap[_curNum];
        let curRunNodeActionList = isChild ? that.state.childActions[0][_curNum] : curActions[_curNum];
        // console.log('curRunNodeActionList:', curRunNodeActionList)

        //获取当前节点的父节点
        //let parentNode = returnScore || that.state.curRunChildNodeParent || that.state.actions[that.state.curPage][that.state.curRunNodeNum][0];

        if (curRunNodeQueue && curRunNodeQueue.isFinished && curRunNodeQueue.isFinished === 1) {
            //节点已经渲染完成
            if (isChild) {
                that.setState({
                    curRunChildNodeNum: (parseInt(_curNum, 10) + 1).toString(),
                });
            } else {
                //查找兄弟的 isFinished
                let getBrotherIsFinished = function (lastNum) {
                    let prevNodeNum = lastNum - 1;
                    if (prevNodeNum >= 0) {
                        let prevNode = curRunMap[prevNodeNum];
                        if (!(prevNode && prevNode.isFinished && prevNode.isFinished === 1)) {
                            return 0;
                        } else {
                            getBrotherIsFinished(prevNodeNum - 1);
                        }
                        return 1;
                    } else {
                        return 1;
                    }
                };
                let brotherIsFinished = getBrotherIsFinished(_curNum);
                if (brotherIsFinished === 1) {
                    //兄弟节点都渲染完成
                    that.runNextNodeOrPage(false);
                } else {
                    //兄弟节点没有渲染完成
                    that.setState({
                        curRunNodeNum: (parseInt(_curNum, 10) + 1).toString(),
                    });
                }

                // that.setState({
                //     curRunNodeNum: (parseInt(_curNum, 10) + 1).toString(),
                // });
            }
        } else if (curRunNodeActionList && curRunNodeActionList.length) {
            // let delay = curRunNodeQueue.delay || 0;
            // setTimeout(() => {
            let showChildPageNodes = that.state.showChildPageNodes;
            if (isChild) {
                if (showChildPageNodes.length === 0) {
                    showChildPageNodes.push([]);
                } else if (!showChildPageNodes[that.state.curRunChildIndex]) {
                    showChildPageNodes[that.state.curRunChildIndex] = [];
                }
                showChildPageNodes[that.state.curRunChildIndex].push.apply(showChildPageNodes[that.state.curRunChildIndex], curRunNodeActionList);
            }
            let updateObj = isChild
                ? {
                    // showChildPageNodes: that.state.showChildPageNodes.concat(curRunNodeActionList)//Array.prototype.push.apply(showChildPageNodes, curRunNodeActionList)//
                    showChildPageNodes: showChildPageNodes,
                }
                : {
                    showPageNodes: that.state.showPageNodes.concat(curRunNodeActionList),
                };
            that.setState(updateObj, () => {
                let needWait = false; //需要暂停节点渲染，例如遇见视频和需要用户交互的节点
                for (let i = 0; i < curRunNodeActionList.length; i++) {
                    let curRunNodeActionItem = curRunNodeActionList[i];

                    if (curRunNodeActionItem.starSubject === 1) {
                        that.setState({
                            currSubjectCount: currSubjectCount + 1,
                        });
                    }

                    //拉全屏，有动效
                    if (
                        (curRunNodeActionItem.detail.toCenter && curRunNodeActionItem.detail.toCenter === 1) ||
                        curRunNodeActionItem.actionType === 'CircleGameInteraction_' ||
                        curRunNodeActionItem.actionType === 'ASRInteraction_' ||
                        curRunNodeActionItem.actionType === 'FacsimileGameInteraction_' ||
                        curRunNodeActionItem.actionType === 'ChooseWrongWordsInteraction_' ||
                        curRunNodeActionItem.actionType === 'ChooseRightWordsInteraction_'
                    ) {
                        if (that.state.isCourseTeacherExchange) {
                            //当老师视频和课间区是互换的，那先换回来，然后再拉全屏
                            that.changeCourseTeacherExchange(false, () => {
                                that.setState({
                                    toCenter: 1,
                                    isCourseTeacherExchange: false,
                                });
                            });
                        } else {
                            that.setState({
                                toCenter: 1,
                            });
                        }
                        window.toCenter = 1;
                        // 在小米等部分机型下，微信x5浏览器视频最顶层没办法覆盖，而且不支持cavans的drawImage
                        if (window.isX5) {
                            const teachVideo = document.getElementById('teachVideo');
                            teachVideo && (teachVideo.style.display = 'none');
                        }
                    }

                    //全屏，无动效
                    if (curRunNodeActionItem.actionType === 'ExpandCourse_') {
                        let handleFun = () => {
                            that.setState({
                                expandCourse: true,
                            });
                            if (window.needRecoRecordCourse && !window.isRecordingVideo) {
                                WebRTC.startRecordVideo();
                            }
                        }
                        if (that.state.isCourseTeacherExchange) {
                            //当老师视频和课间区是互换的，那先换回来，然后再拉全屏
                            that.changeCourseTeacherExchange(false, () => {
                                handleFun();
                            });
                        } else {
                            handleFun();
                        }
                    }

                    //清除划过的圈
                    if (curRunNodeActionItem.actionType === 'CleanCircle_') {
                        that.cleanCircle();
                    }

                    //记录回放的节点key
                    if (window.needRecoRecordCourse) {
                        window.curPageSceneList = that.sceneList[that.state.curPage]; //初始化
                        if (
                            curRunNodeActionItem.actionType === 'ASRInteraction_' ||
                            curRunNodeActionItem.actionType === 'CircleGameInteraction_' ||
                            curRunNodeActionItem.actionType === 'MutiMatchGameInteraction_' ||
                            curRunNodeActionItem.actionType === 'AudioMutiMatchGameInteraction_' ||
                            curRunNodeActionItem.actionType === 'MutiMatchGameWithDoneInteraction_' ||
                            curRunNodeActionItem.actionType === 'FacsimileGameInteraction_' ||
                            curRunNodeActionItem.actionType === 'FlipFlopGameInteraction_'
                        ) {
                            window.recordPageTime = new Date().getTime();
                            // window.keyStr = window.keyStr ? window.keyStr : `.timeline.nodes[${that.state.curRunNodeNum}].actions[${i}]`;
                            // window.keyStr = `.timeline.nodes[${that.state.curRunNodeNum}].actions[${i}]`;
                            if (isChild) {
                                window.keyStr += `.detail.timeline.nodes[${that.state.curRunChildNodeNum}].actions[${i}]`;
                            } else {
                                window.keyStr = window.keyStr ? window.keyStr : `.timeline.nodes[${that.state.curRunNodeNum}].actions[${i}]`;
                            }
                        }
                        if (curRunNodeActionItem.actionType === 'ASRandJudge_') {
                            if (isChild) {
                                window.keyStr += `.detail.timeline.nodes[${that.state.curRunChildNodeNum}].actions[${i}]`;
                            }
                        }
                        // console.log(window.keyStr)
                    }

                    //guess动画
                    if (curRunNodeActionItem.actionType === 'DropDownPics_') {
                        //掉落图片，resourceIDs是一个数组，里面是图片的resourceid，说明这些图片都需要掉落。
                        //animType是掉落动效类型，目前有0和1两种。0是晃动一下，再掉落；1是直接掉落。
                        let resourceIDs = curRunNodeActionItem.detail.resourceIDs;
                        let animType = curRunNodeActionItem.detail.animType;
                        if (resourceIDs && resourceIDs.length) {
                            for (let i = 0; i < resourceIDs.length; i++) {
                                let animationDiv = document.getElementById(resourceIDs[i]);
                                if (animationDiv) {
                                    if (animType === 0) {
                                        setTimeout(() => {
                                            animationDiv.setAttribute('class', 'dd');
                                        }, 500);
                                        //抖动动画完成后做掉落动画
                                        animationDiv.addEventListener('webkitAnimationEnd', function () {
                                            setTimeout(
                                                () => {
                                                    animationDiv.setAttribute('class', 'move-down');
                                                },
                                                i === 0 ? 0 : Math.floor(Math.random() * 500)
                                            ); //添加一个随机掉落时间
                                        });
                                    } else if (animType === 1) {
                                        setTimeout(() => {
                                            animationDiv.setAttribute('class', 'move-down');
                                        }, Math.floor(Math.random() * 800)); //添加一个随机掉落时间
                                    }
                                }
                            }
                        }
                    }

                    if (curRunNodeActionItem.detail && curRunNodeActionItem.detail.timeline) {
                        //还有子timeline
                        needWait = true;
                        let newChildAcrionList = [];
                        newChildAcrionList.push(curRunNodeActionItem.detail);
                        that.formatSceneList(newChildAcrionList, true, curRunNodeActionItem);
                    } else if (curRunNodeActionItem.actionType === 'PlayVideo_' && curRunNodeActionItem.objectID === 'Teacher_') {
                        //教师区视频
                        needWait = true;
                        let newVideo = that.state.playingVideo;
                        newVideo.url = curRunNodeActionItem.detail.url;
                        newVideo.isChild = isChild ? true : false;
                        newVideo.isPlaying = true;
                        newVideo.nodeNum = _curNum;

                        if (window.isDev) {
                            newVideo.url = newVideo.url.replace('putaoabc-inc.com', 'course.putaoabc.net.cn').replace('inner.putaoabc.net.cn:5002', 'course.putaoabc.net.cn');
                        }

                        if (curRunNodeActionItem.detail.sayNameTime) {
                            newVideo.sayNameTime = curRunNodeActionItem.detail.sayNameTime;
                        }

                        let setVideo = (newVideoObj) => {
                            that.setState({
                                playingVideo: newVideoObj,
                                isCourseTeacherExchange: curRunNodeActionItem.detail.courseTeacherExchange && curRunNodeActionItem.detail.courseTeacherExchange === 1 ? true : false,
                            });
                        }

                        if (videoDownloadProgress > 0) {
                            putaoWS.getVideoIsExist(newVideo.url, (isExist) => {
                                if (isExist) {
                                    newVideo.url = newVideo.url.replace(that.cresDomain, that.localDomain); //"http://127.0.0.1:23080/level2/unit1/lesson4/1575343252/video/L25-1_s.mp4";
                                    setVideo(newVideo);
                                } else {
                                    setVideo(newVideo);
                                }
                            });
                        } else {
                            setVideo(newVideo);
                        }
                    } else if (curRunNodeActionItem.actionType === 'TeacherTest_') {
                        //扫码测试的教师区视频，5s后模式视频播放完
                        let newVideo = that.state.playingVideo;
                        newVideo.url = curRunNodeActionItem.comment;
                        newVideo.isChild = isChild ? true : false;
                        newVideo.isPlaying = true;
                        newVideo.nodeNum = 'TeacherTest_';
                        needWait = true;
                        that.setState({
                            playingVideo: newVideo,
                            toCenter: 2,
                        }, () => {
                            setTimeout(() => {
                                that.handleVideoEnd(isChild);
                            }, 5000);
                            window.toCenter = 2;
                        });
                    } else if (curRunNodeActionItem.actionType === 'GetTimelineByCallFunction_Native_') {
                        //判断是否给星星，勋章系统去掉
                        if (window.medalOnOff) {
                            that.runNextNodeOrPage(true);
                        } else {
                            const judgeFunction = curRunNodeActionItem.detail.function;
                            if (judgeFunction) {
                                let returnScore = JSON.parse(window[judgeFunction](curRunNodeActionItem.detail.params));
                                if (returnScore && returnScore.links && returnScore.nodes) {
                                    let startCallback = [];
                                    startCallback.push({ timeline: returnScore });
                                    that.formatSceneList(startCallback, true, returnScore);
                                } else {
                                    that.runNextNodeOrPage(true);
                                }
                            }
                        }
                    } else if (curRunNodeActionItem.actionType === 'PlayAnimation_') {
                        let playAnimation = document.getElementById('playAnimation');
                        playAnimation.removeAttribute('class');
                        lottie.loadAnimation({
                            container: playAnimation,
                            renderer: 'svg',
                            loop: false,
                            autoplay: true,
                            path: window.resourceUrl + 'animation/' + curRunNodeActionItem.detail.resourceID,
                        });

                        if (curRunNodeQueue) {
                            curRunNodeQueue.isFinished = 1;
                        }
                    } else if (curRunNodeActionItem.actionType === 'PlayAudio_') {
                        //播放音频
                        setTimeout(
                            () => {
                                let playAudio = document.getElementById('playAudio');
                                if (isChild) {
                                    playAudio = document.getElementById('playAudioChild');
                                }
                                playAudio.setAttribute('src', window.resourceUrl + 'audio/' + curRunNodeActionItem.detail.resourceID);
                            },
                            that.state.isCourseTeacherExchange ? 300 : 0
                        );
                    } else if (curRunNodeActionItem.actionType === 'GiveStar_') {
                        //GiveStar_ 老师在场给星星，遇见这个星星就加1，不能超过5颗
                        let playAnimation = document.getElementById('playAnimation');
                        playAnimation.removeAttribute('class');
                        lottie.loadAnimation({
                            container: playAnimation,
                            renderer: 'svg',
                            loop: true,
                            autoplay: true,
                            path: window.animationUrl + 'star_data.json',
                        });

                        let giveStar = document.getElementById('giveStar');
                        if (giveStar) {
                            giveStar.setAttribute('class', 'move-star move-' + (currStarCount + 1));
                        }
                        setTimeout(() => {
                            that.setState({
                                currStarCount: currStarCount + 1,
                            });
                        }, 1400);
                    } else if (curRunNodeActionItem.actionType === 'GiveStar2_') {
                        //GiveStar2_ 拉全屏给星星，遇见这个星星就加1，不能超过5颗

                        let giveStartFun = () => {
                            that.setState({
                                // expandCourse: true
                                toCenter: 1,
                            }, () => {
                                window.toCenter = 1;
                                let playAnimation = document.getElementById('playAnimation');
                                playAnimation.removeAttribute('class');
                                lottie.loadAnimation({
                                    container: playAnimation,
                                    renderer: 'svg',
                                    loop: false,
                                    autoplay: true,
                                    path: window.animationUrl + 'star_data.json',
                                });

                                let giveStar = document.getElementById('giveStar');
                                if (giveStar) {
                                    giveStar.setAttribute('class', 'move-star move-' + (currStarCount + 1));
                                }
                                setTimeout(() => {
                                    that.setState({
                                        currStarCount: currStarCount + 1,
                                    });
                                }, 1400);
                            });
                            if (window.isX5) {
                                const teachVideo = document.getElementById('teachVideo');
                                teachVideo && (teachVideo.style.display = 'none');
                            }
                        };

                        if (that.state.isCourseTeacherExchange) {
                            that.changeCourseTeacherExchange(false, () => {
                                giveStartFun();
                            });
                        } else {
                            giveStartFun();
                        }
                    } else if (curRunNodeActionItem.actionType === 'BorderPic_') {
                        //圈图动画
                        let resourceID = curRunNodeActionItem.detail.resourceID;
                        let getResourceID = document.getElementById(resourceID);
                        if (getResourceID) {
                            // getResourceID.style.border = "3px solid #F00";
                            getResourceID.style.outline = '#F00 solid 3px';
                            if (curRunNodeActionItem.detail.isRound === 1) {
                                getResourceID.style.borderRadius = getResourceID.clientWidth + 'px';
                            }
                        }

                        if (curRunNodeQueue) {
                            curRunNodeQueue.isFinished = 1;
                        }

                        //圈图获取正确答案以后，去掉用户的圈   ---添加CleanCircle_就先注释
                        // that.cleanCircle();
                    } else if (curRunNodeActionItem.actionType === 'DisappearObj_') {
                        //消失动画
                        let resourceID = curRunNodeActionItem.detail.resourceID;
                        let getResourceID = document.getElementById(resourceID);
                        if (getResourceID) {
                            getResourceID.style.display = 'none';

                            // cid=2_2_3&page=20 圈图完以后会进入语音交互，要去掉圆圈   ---添加CleanCircle_就先注释
                            // that.cleanCircle();
                        }

                        if (curRunNodeQueue && !needWait) {
                            //cid=2_3_1&page=11  PlayVideo_ 和 DisappearObj_ 在一级，因此不能直接改isFinished = 1，这种写法可能有问题，假如 DisappearObj_ 在 PlayVideo_ 前也会设置 isFinished = 1
                            curRunNodeQueue.isFinished = 1;
                        }
                    } else if (
                        curRunNodeActionItem.actionType === 'ASRandJudge_' ||
                        curRunNodeActionItem.actionType === 'CircleGameInteraction_' ||
                        curRunNodeActionItem.actionType === 'MutiMatchGameInteraction_' ||
                        curRunNodeActionItem.actionType === 'AudioMutiMatchGameInteraction_' ||
                        curRunNodeActionItem.actionType === 'MutiMatchGameWithDoneInteraction_' ||
                        curRunNodeActionItem.actionType === 'ChooseWrongWordsInteraction_' ||
                        curRunNodeActionItem.actionType === 'ChooseRightWordsInteraction_'
                    ) {
                        needWait = true;
                        window.isRuningActionName = curRunNodeActionItem.actionType;

                        //done模板
                        if (
                            !that.state.doneTryData &&
                            curRunNodeActionItem.actionType === 'MutiMatchGameWithDoneInteraction_' &&
                            isChild &&
                            !curRunNodeActionItem.retryTimes
                        ) {
                            //第二次done
                            // window.doneTryData = {
                            //     restoreOption: curRunNodeActionItem.detail.restoreOption,
                            //     feedbacks: curRunNodeActionItem.detail.feedbacks,
                            //     retryTimes: curRunNodeActionItem.detail.retryTimes || 0,
                            //     needMatch: true
                            // };
                            let _restoreOption = {
                                restoreOption: curRunNodeActionItem.detail.restoreOption,
                                feedbacks: curRunNodeActionItem.detail.feedbacks,
                                retryTimes: curRunNodeActionItem.detail.retryTimes || 0,
                                needMatch: true,
                            };
                            that.setState({
                                doneTryData: _restoreOption,
                            });
                        }
                    } else if (curRunNodeActionItem.actionType === 'MatchGame_ShowAnswer_') {
                        //done模板显示正确答案
                        // window.doneTryData = {
                        //     restoreOption: 2,
                        //     needMatch: false
                        // };
                        // setTimeout(() => {
                        //     window.doneTryData = {
                        //         restoreOption: 3,
                        //         needMatch: false
                        //     };
                        // }, 500);
                        let _restoreOption = {
                            restoreOption: 2,
                            needMatch: false,
                            retryTimes: -1,
                            // feedbacks: null
                        };
                        that.setState({
                            doneTryData: _restoreOption,
                        }, () => {
                            setTimeout(() => {
                                let _restoreOption = {
                                    restoreOption: 3,
                                    needMatch: false,
                                };
                                that.setState({
                                    doneTryData: _restoreOption,
                                });
                            }, 500);
                        });
                    } else if (curRunNodeActionItem.actionType === 'CancelCourseToCenter_') {
                        //取消拉全屏
                        // if (isChild) {
                        //     that.setState({
                        //         // toCenter: 2, //因为加了视频开始播放就取消拉全屏的逻辑，因此这个地方先不用了，直接渲染下一节点
                        //         curRunChildNodeNum: (parseInt(_curNum, 10) + 1).toString(),
                        //     });
                        // } else {
                        //     that.setState({
                        //         curRunNodeNum: (parseInt(_curNum, 10) + 1).toString(),
                        //     });
                        // }

                        //cid=2_2_1&page=4  拉全屏有子节点需要渲染
                        if (curRunNodeQueue) {
                            curRunNodeQueue.isFinished = 1;
                            that.getSonNodes(curRunNodeQueue, isChild ? true : false);
                        } else {
                            if (isChild) {
                                that.setState({
                                    // toCenter: 2, //因为加了视频开始播放就取消拉全屏的逻辑，因此这个地方先不用了，直接渲染下一节点
                                    curRunChildNodeNum: (parseInt(_curNum, 10) + 1).toString(),
                                });
                            } else {
                                that.setState({
                                    curRunNodeNum: (parseInt(_curNum, 10) + 1).toString(),
                                });
                            }
                        }
                    } else if (
                        //判断渲染节点列表的最后一个节点完成后是否需要查找子节点是否完成
                        curRunNodeActionItem.actionID === curRunNodeActionList[curRunNodeActionList.length - 1].actionID && //渲染到最后一个节点
                        curRunNodeActionItem.actionType !== 'PlayVideo_' && //有视频的需要播放完视频才能渲染后面的
                        curRunNodeActionItem.actionType !== 'MutiMatchGameInteraction_'
                        // && curRunNodeActionItem.actionType !== "MutiMatchGameWithDoneInteraction_"
                        // && curRunNodeActionItem.actionType !== "ASRInteraction_"
                        // && curRunNodeActionItem.actionType !== "CircleGameInteraction_"
                        // && curRunNodeActionItem.actionType !== "AudioMutiMatchGameInteraction_"
                        // && curRunNodeActionItem.actionType !== "FacsimileGameInteraction_"
                        // && curRunNodeActionItem.actionType !== "FlipFlopGameInteraction_"
                        // || _curNum === Object.keys(curActions).length   //渲染到最后一个节点
                    ) {
                        if (curRunNodeQueue) {
                            if (!needWait) {
                                curRunNodeQueue.isFinished = 1;
                            }

                            let fatherNodes = curRunNodeQueue.fatherNodes[0];
                            let isFinished = curRunMap[fatherNodes].isFinished;
                            let sonNodes = curRunNodeQueue.sonNodes;
                            if (sonNodes && sonNodes.length && isFinished === 1 && curRunNodeQueue.isFinished === 1) {
                                //父级isFinished，自身isFinished
                                that.getSonNodes(curRunNodeQueue, isChild);
                            } else {
                                //渲染完最后一个节点，兼容最后一页老师区没有视频
                                if (!needWait && parseInt(_page, 10) === that.state.totalPage - 1) {
                                    if (that.cid) {
                                        that.finishSendLessonStat();
                                    }
                                    that.setState({
                                        complete: true,
                                    });
                                    if (window.isX5) {
                                        const teachVideo = document.getElementById('teachVideo');
                                        teachVideo && (teachVideo.style.display = 'none');
                                    }
                                } else if (isChild) {
                                    // try {
                                    //     let childActionsArr = that.state.childActions[0];
                                    //     console.log(_curNum, Object.keys(childActionsArr).length)
                                    //     let playingVideo = that.state.playingVideo;
                                    //     if(!needWait && _curNum < Object.keys(childActionsArr).length && !sonNodes && !playingVideo.url) {
                                    //         that.runNextNodeOrPage(isChild);
                                    //     }
                                    // } catch(err) {}
                                }
                            }

                            // that.getSonNodes(curRunNodeQueue);
                        }
                    }
                }
            });
            // }, delay || 0);
        } else {
            if (curRunNodeQueue) {
                curRunNodeQueue.isFinished = 1;
                that.getSonNodes(curRunNodeQueue, isChild ? true : false);
            } else if (isChild) {
                that.runNextNodeOrPage(false);
            }
        }
    }

    runNextNodeOrPage(isChild, curVideo) {
        const that = this;
        const { totalPage, curPage, queue, curRunNodeNum, childQueue, curRunChildNodeNum, playingVideo } = this.state;
        if (isChild && childQueue && parseInt(curRunChildNodeNum, 10) < Object.keys(childQueue[0]).length - 1) {
            //渲染到最后一个子节点
            that.setState({
                curRunChildNodeNum: (parseInt(curRunChildNodeNum, 10) + 1).toString(),
                playingVideo: curVideo ? curVideo : playingVideo,
            });
        } else if (isChild) {
            window.keyStr = ''; //没有子类节点运行了置空，兼容一页多个交互的情况
            that.runNextNodeOrPage(false, curVideo);
        } else {
            let curNodeQueue = queue[curPage][curRunNodeNum]; //当前节点队列

            let lastNum = curRunNodeNum;
            if (curNodeQueue && parseInt(lastNum, 10) === Object.keys(curNodeQueue).length - 1) {
                //当子timeline渲染到最后一个子节点了，而且兄弟节点的isFinised=1，把其上一级的isFinised改为1
                curNodeQueue.isFinished = 1;
            }

            //当当前运行节点有子节点，检测其父节点 isFinished=1，然后运行子节点
            let curNodeQueueFatherNodes = curNodeQueue.fatherNodes[0]; //当前节点父节点
            let curNodeQueuesSonNodes = curNodeQueue.sonNodes; //当前节点子节点
            if (curNodeQueuesSonNodes && curNodeQueuesSonNodes.length && queue[curPage][curNodeQueueFatherNodes].isFinished === 1) {
                //存在子节点 && 父节点已完成
                that.getSonNodes(curNodeQueue);
            } else {
                if (parseInt(curRunNodeNum, 10) < Object.keys(queue[curPage]).length - 1) {
                    //没有渲染到最后一个节点，继续渲染下一个节点 curRunNodeNum + 1
                    that.setState({
                        curRunNodeNum: (parseInt(curRunNodeNum, 10) + 1).toString(),
                        playingVideo: curVideo ? curVideo : playingVideo,
                    });
                } else {
                    if (parseInt(curPage, 10) < totalPage - 1) {
                        that.resetNodeNum(function () {
                            that.setState({
                                curPage: (parseInt(curPage, 10) + 1).toString(),
                            });
                        });
                    } else {
                        if (that.cid) {
                            that.finishSendLessonStat();
                        }
                        that.setState({
                            complete: true,
                        });
                        if (window.isX5) {
                            const teachVideo = document.getElementById('teachVideo');
                            teachVideo && (teachVideo.style.display = 'none');
                        }
                    }
                }
            }
        }
    }

    // 切换老师和课程区域
    changeCourseTeacherExchange(isChange, callback) {
        const that = this;
        const $content_course = $('#content');
        const $teacher_video = $('#teacherVideoContent');

        $content_course.animate({
            // width: $teacher_w,
            // height: $teacher_h,
            top: isChange ? '6%' : 0,
            left: isChange ? 0 : that.changeCourseLeft,
            zoom: isChange ? that.changeCoursePercent : 1,
            borderRadius: isChange ? 15 / that.changeCoursePercent : 15,
        }, 300);
        $teacher_video
            .animate({
                // width: $content_w,
                // height: $content_h,
                top: isChange ? 0 : '6%',
                left: isChange ? parseInt(284 * window.mainSize.percent) * that.changeCoursePercent : 0, //parseInt($content_course.css("left"))
                zoom: isChange ? that.changeTeacherPercent : 1,
                borderRadius: isChange ? 15 / that.changeTeacherPercent : 15,
            }, 300, () => {
                if (callback && typeof callback === 'function') {
                    callback();
                }
            })
            .find('#myCanvas')
            .css({
                borderRadius: isChange ? 15 / that.changeTeacherPercent : 15,
            });
    }

    reloadNextPageImg() {
        const that = this;
        const { curPage, actions } = this.state;
        const curActions = actions[parseInt(curPage, 10) + 1];
        if (curActions) {
            for (let i = 0; i < Object.keys(curActions).length; i++) {
                let curItemArr = curActions[i];
                if (curItemArr && curItemArr.length) {
                    for (let j = 0; j < curItemArr.length; j++) {
                        let item = curItemArr[j];
                        if (item.actionType === 'ShowPic_' && item.detail && item.detail.resourceID) {
                            that.nextPageImgArr.push(item.detail.resourceID);
                        }
                    }
                }
            }
        }
    }

    //获取子类
    getSonNodes(curRunNodeQueue, isChildTimeline) {
        const that = this;
        let sonNodes = curRunNodeQueue.sonNodes;
        let delay = curRunNodeQueue.sonDelay || [];
        if (sonNodes && sonNodes.length) {
            sonNodes.forEach((sonNode, index) => {
                setTimeout(() => {
                    if (isChildTimeline) {
                        that.setState({
                            curRunChildNodeNum: sonNode,
                        });
                    } else {
                        that.setState({
                            curRunNodeNum: sonNode,
                        });
                    }
                }, delay[index] || 0);
            });
        }
    }

    handleVideoPlay() {
        const that = this;
        const { toCenter } = this.state;
        // console.log('视频ing: ' + that.state.playingVideo.url);

        let playFun = () => {
            const teachVideo = document.getElementById('teachVideo');
            let playPromise = teachVideo.play();
            if (playPromise !== undefined) {
                playPromise
                    .then(_ => {
                        that.setState({
                            isPause: false,
                        }, () => {
                            //录屏
                            if (window.needRecoRecordCourse && !window.isRecordingVideo && that.state.hasDevices && !that.state.isPause) {
                                WebRTC.startRecordVideo();
                            }

                            //canvas每当高度或宽度被重设时，画布内容就会被清空
                            if (that.isCanvasLastVideoPic) {
                                const c = document.getElementById('myCanvas');
                                c.height = c.height;
                            }
                        });
                    })
                    .catch(error => {
                        utils.showTips("播放失败，点击这里继续", -1, () => {
                            playFun();
                        });
                    });
            }
            isSafari && that.reSizeCursor();
        };

        if (toCenter === 1) {
            //全屏状态
            that.setState({
                toCenter: 2,
            }, () => {
                window.toCenter = 2;
                window.isRuningActionName = "";
                if (that.state.isCourseTeacherExchange) {
                    setTimeout(() => {
                        that.changeCourseTeacherExchange(true, () => {
                            playFun();
                        });
                        that.setState({
                            toCenter: 0,
                        });
                        window.toCenter = 0;
                    }, 500);
                } else {
                    setTimeout(() => {
                        that.setState({
                            toCenter: 0,
                        });
                        window.toCenter = 0;
                    }, 500);
                    playFun();
                }
                if (window.isX5) {
                    const teachVideo = document.getElementById('teachVideo');
                    teachVideo && (teachVideo.style.display = 'block');
                }
            });
        } else {
            playFun();
            that.changeCourseTeacherExchange(that.state.isCourseTeacherExchange, () => {
                // playFun();   //放在这里 ，第一页第一个视频和课间区切换会先白屏一下在开始播放，因此想放外面去
            });
        }
    }

    /**
     * isChild - 是否是播放子timeline下nodes的视频
     *  isChild = true，改变 curRunChildNodeNum 的值；
     *  isChild = false，改变 curRunNodeNum 的值；
     *  注意：每次生成 childQueue 数组第一层用的key是 map方法的 index，因此取第一层用 childQueue[0]
     * isAudio 是否是音频，有视频音频同时播的情况，播完音频若还有时间在播放，则不走后面逻辑
     */
    handleVideoEnd(isChild, isAudio) {
        const that = this;
        const { curPage, queue, curRunNodeNum, childQueue, curRunChildNodeNum, playingVideo } = this.state;
        let nodeNum = isChild ? curRunChildNodeNum : curRunNodeNum;
        let _pageQueue = isChild ? (childQueue ? childQueue[0] : null) : queue[curPage];
        if (isAudio) {
            that.clearAnimation();
            let fatherNodes = _pageQueue && _pageQueue[nodeNum] && _pageQueue[nodeNum].fatherNodes ? _pageQueue[nodeNum].fatherNodes : null;
            _pageQueue[nodeNum].isFinished = 1; //当前视频的节点
            if (fatherNodes && fatherNodes.length) {
                _pageQueue[fatherNodes[0]].isFinished = 1;
            }
        } else {
            if (playingVideo.nodeNum > -1) {
                _pageQueue[playingVideo.nodeNum].isFinished = 1; //当前视频的节点
                let fatherNodes = _pageQueue[nodeNum].fatherNodes;
                if (fatherNodes && fatherNodes.length) {
                    _pageQueue[fatherNodes[0]].isFinished = 1; //视频节点的父节点，也视为完成？
                }
            }

            // 改为视频播放结束绘制最后一帧放在视频下面，防止换视频闪一下
            if (that.isCanvasLastVideoPic) {
                const v = document.getElementById('teachVideo');
                const c = document.getElementById('myCanvas');
                const ctx = c.getContext('2d');
                ctx.drawImage(v, 0, 0, v.videoWidth || 690, v.videoHeight || 518, 0, 0, v.videoWidth || 690, v.videoHeight || 518);
            }
        }
        if (isAudio && playingVideo.isPlaying) return;
        playingVideo.isPlaying = false;
        playingVideo.url = ''; //视频结束如下一个视频的url相同，会不播放，因此清掉
        playingVideo.nodeNum = -1;
        that.runNextNodeOrPage(isChild, playingVideo);
        clearInterval(that.intervalCanvasImg);
    }

    //视频加载错误
    handleVideoError(url) {
        const that = this;
        const { playingVideo } = this.state;
        if (url) {
            console.log('视频加载出错: ' + url);
            try {
                window.PTMonitor.report({
                    type: 'mediaEx',
                    url: window.location.href,
                    putaoid: window.PuTaoA.getCookie('putaoid'),
                    stack: 'handleVideoError',
                    info: url,
                }, window.EX_TYPE.mediaEx);
            } catch (error) { }

            if (url.indexOf(that.localDomain) > -1) {
                playingVideo.url = playingVideo.url.replace(that.localDomain, "https://cres.putaoabc.com");
                that.setState({
                    playingVideo: playingVideo
                });
            } else {
                that.runNextNodeOrPage();
            }
        } else {
            that.runNextNodeOrPage();
        }
        // cid=2_1_4&page=6  的 L7-11_s.mp4  视频会进入错误播10遍，因此先注释掉
        // if (playingVideo.url.indexOf('?') > -1) {
        //     playingVideo.url = playingVideo.url.split('?')[0] + '?t=' + window.reTryTime;  //视频结束如下一个视频的url相同，会不播放，因此清掉
        // } else {
        //     playingVideo.url = playingVideo.url + '?t=' + window.reTryTime;
        // }

        // if (window.reTryTime < 10) {
        //     setTimeout(() => {
        //         window.reTryTime++;
        //         that.setState({
        //             playingVideo: playingVideo
        //         })
        //         console.log(document.getElementById("teachVideo").networkState)
        //     }, 500);
        // } else {
        //     that.runNextNodeOrPage();
        // }
    }

    clearAnimation() {
        let playAnimation = document.getElementById('playAnimation');
        if (playAnimation) {
            playAnimation.innerHTML = ''; //清空动画容器
            playAnimation.setAttribute('class', 'hide'); //清空动画容器
        }
    }

    handleChildCallback(returnScore, replaceData) {
        const that = this;

        //写入回放上报数据
        if (window.needRecoRecordCourse && replaceData) {
            try {
                that.sceneList[that.state.curPage] = JSON.parse(replaceData);
            } catch (err) {
                console.log(err);
            }
        }

        if (returnScore && returnScore.resultInfo && returnScore.timeline && returnScore.timeline.nodes) {
            //that.handleCourseComplete();
            that.setState({
                childQueue: null,
                childActions: null,
                // showChildPageNodes: [],  //存放当前子timeline需要渲染的节点列表
                // curRunChildNodeNum: "0", //当前渲染的子节点序号

                // showChildPageNodes: that.state.showChildPageNodes.length ? that.state.showChildPageNodes : [],  //存放当前子timeline需要渲染的节点列表
                // curRunChildNodeNum: "0", //当前渲染的子节点序号
                // curRunChildIndex: that.state.showChildPageNodes.length ? that.state.curRunChildIndex : 0,
            }, () => {
                let newChildAcrionList = [];
                newChildAcrionList.push(returnScore);
                that.formatSceneList(newChildAcrionList, true, returnScore);
            });

            // that.setState({
            //     showChildPageNodes: that.state.showChildPageNodes.push(returnScore.timeline)//Array.prototype.push.apply(showChildPageNodes, curRunNodeActionList)//
            // });
        } else {
            // const curRunMap = that.state.queue[that.state.curPage];
            // curRunMap[curRunMap.nodeNum].isFinished = 1;    //当前视频的节点
            // curRunMap[curRunMap[that.state.curRunNodeNum].fatherNodes[0]].isFinished = 1;    //视频节点的父节点，也视为完成？

            that.runNextNodeOrPage(true);
        }
    }

    resetNodeNum(callback) {
        const that = this;
        that.setState({
            curRunNodeNum: '0',
            showPageNodes: [],

            childQueue: null,
            childActions: null,
            curRunChildNodeNum: '0',
            showChildPageNodes: [],
        }, () => {
            if (typeof callback === 'function') {
                callback();
            }
            //that.changePage(parseInt(curPage) + 1);
        });
    }

    //needSendStart-是否发送开始学习统计
    startWork(needSendStart) {
        const that = this;
        const { localStorageInfo } = this.state;
        window.beginTime = parseInt(new Date().getTime() / 1000, 10);
        if (that.cid) {
            if (needSendStart) {
                that.startSendLessonStat();
            } else {
                //读缓存继续学习页需要发统计
                that.duration = localStorageInfo.duration || 0;
                // 再次写入缓存，因为changePage会先于startWork执行，不重置继续学习会导致that.duration为0
                that.setLocalStorage();
                that.setState({
                    localStorageInfo: null,
                });
            }

            //开始统计学习时长
            that.handleDuration();

            Utils.sendStatRequest('/lesson/situation2', {
                putaoid: that.putaoid,
                token: decodeURIComponent(that.token),
                cid: that.cid,
                beginTime: window.beginTime,
                starttime: window.startTime,
                action: 'begin',
                device: Utils.getDevice(),
                duration: 0,
                isFinished: 0,
                score: 0,
                stars: needSendStart ? 0 : that.state.currStarCount,
                from: 'pc',
                useReplay: 1,
            });

            that.getMedalList();

            document.addEventListener("visibilitychange", () => {
                if (document.hidden) {
                    that.handlePlayPauseCourse(true);
                } else {
                    that.handlePlayPauseCourse(false);
                }
            }, false);

        }
    }

    // 计算学习时长
    handleDuration() {
        const that = this;
        that.durationTimer = setInterval(() => {
            that.duration++
            // console.log(that.duration)
        }, 1000);
    }

    //检测到允许摄像头，开始学习，绘制老师图像
    drawTeacherImage() {
        const that = this;
        //在canvas中播放视频
        const v = document.getElementById('teachVideo');
        const c = document.getElementById('myCanvas');
        const ctx = c.getContext('2d');

        if (!that.isCanvasLastVideoPic) {
            v.addEventListener('pause', function () {
                clearInterval(that.intervalCanvasImg);
            });

            // // 每 videoPlayTimeInterval ms画一次图
            v.addEventListener('play', function () {
                that.intervalCanvasImg = window.setInterval(function () {
                    ctx.drawImage(v, 0, 0, v.videoWidth || 690, v.videoHeight || 518, 0, 0, v.videoWidth || 690, v.videoHeight || 518);
                    if (v.ended) {
                        clearInterval(that.intervalCanvasImg);
                    }
                }, videoPlayTimeInterval);
            });
        }

        //获取视频的播放时间，获取的时间有一个小于300ms左右的间隔
        let prevTimeDisplay;
        v.addEventListener('timeupdate', function () {

            // vip外教第一页第一个视频跳过前6s
            if (!that.vipSkipVideoTime && parseInt(that.state.curPage, 10) === 0 && that.project === "vipbingo") {
                v.currentTime = 6;
                that.vipSkipVideoTime = true;
            }

            let timeDisplay;
            //用秒数来显示当前播放进度
            timeDisplay = v.currentTime * 1000;
            // console.log('timeDisplay:', timeDisplay)

            if (that.state.playingVideo && that.state.playingVideo.sayNameTime) {
                if (that.state.playingVideo.sayNameTime && that.state.playingVideo.sayNameTime.length) {
                    for (let i = 0; i < that.state.playingVideo.sayNameTime.length; i++) {
                        let sayNameTime = that.state.playingVideo.sayNameTime[i];
                        if (sayNameTime - timeDisplay > 0 && sayNameTime - timeDisplay < 290) {
                            //因为获取的播放时间有间隔，没办法找准时间点，通过提前获取最接近的时间点，用 setTimeout 来找准时间差
                            const sayName = document.getElementById('sayName');
                            setTimeout(() => {
                                let sayNamePromise = sayName.play();
                                if (sayNamePromise !== undefined) {
                                    sayNamePromise
                                        .then(_ => {
                                            // console.log('===play', _)
                                        })
                                        .catch(error => {
                                            // console.log('===noplay', error)
                                        });
                                }
                                let newVideo = that.state.playingVideo;
                                delete newVideo.sayNameTime;
                                that.setState({
                                    playingVideo: newVideo,
                                });
                            }, sayNameTime - timeDisplay - 10);
                        }
                    }
                }
            }

            let differ = timeDisplay - prevTimeDisplay;
            if (differ < 0.1 && differ >= 0 && prevTimeDisplay > 0) {
                that.isVideoCarton = true;
                console.log('卡顿 ', prevTimeDisplay);
                that.handleVideoCarton(false);
            } else {
                clearTimeout(that.videoCartonTimer);
                that.isVideoCarton = false;
                that.videoCartonTotalTimes = 0;
                that.setState({
                    showNoNetWorkDialog: false
                });
            }
            prevTimeDisplay = timeDisplay;
        }, false);
    }

    handleVideoCarton(isRetry) {
        const that = this;
        that.videoCartonTimer = setTimeout(() => {
            if (that.isVideoCarton) {
                that.videoCartonTotalTimes += 2000;
                if (!isRetry) {
                    window.PuTaoA.showTips('网络似乎不太好，视频加载中~');
                    try {
                        Utils.postPingBack({
                            videoUrl: that.state.playingVideo && that.state.playingVideo.url ? that.state.playingVideo.url : '',
                            page: that.state.curPage,
                        },
                            {
                                type: 'net_delay',
                                from: 'web',
                                putaoID: that.putaoid,
                                putaoid: that.putaoid,
                                token: that.token,
                                device: ua,
                                uuid: that.uuid,
                                starttime: window.startTime,
                                cid: that.cid,
                            }, 'pb_monitor');
                    } catch (err) { }
                }
                that.handleVideoCarton(true);

                // 超过10s，出加载失败弹窗
                if (that.videoCartonTotalTimes >= 10000) {
                    // that.handlePlayPauseCourse();
                    clearTimeout(that.videoCartonTimer);
                    that.setState({
                        showNoNetWorkDialog: true,
                    });
                }
            } else {
                that.videoCartonTotalTimes = 0;
                clearTimeout(that.videoCartonTimer);
            }
            console.log('that.videoCartonTotalTimes:', that.videoCartonTotalTimes);
        }, 2000);
    }

    handleRetryLoad(flag) {
        const that = this;
        that.setState({
            showNoNetWorkDialog: false,
        }, () => {
            const v = document.getElementById('teachVideo');
            that.setState({
                isPause: false,
            }, () => {
                if (flag) {
                    v.currentTime = 0;
                } else {
                    v.play();
                }
            });
        });
    }

    handlePlayPauseCourse(flag) {   //传入 true 暂停，false 播放
        const that = this;
        const { isPause } = this.state;
        that.setState({
            isPause: typeof flag === "boolean" ? flag : !isPause,
        }, () => {
            let teachVideo = document.getElementById('teachVideo');
            let courseVideo = document.getElementById('courseVideo');
            // 课间区视频也需要暂停
            if (teachVideo && teachVideo.getAttribute('src') === '' && courseVideo && courseVideo.getAttribute('src') !== '') {
                teachVideo = courseVideo;
            }
            if (teachVideo.getAttribute('src') !== '') {
                if (typeof flag === "boolean" ? !flag : isPause) {
                    teachVideo.play();
                    that.handleDuration();
                    if (window.needRecoRecordCourse) {
                        WebRTC.resumeRecordVideo();
                    }

                    if (window.needFfmpegRecordCourse) {
                        putaoWS.startRecordScreen({
                            cosPath: `pc/${that.cid}/${that.putaoid}/${window.startTime}/video/${that.state.curPage}`,
                        });
                        that.isFfmpegRecording = true;
                    }
                } else {
                    teachVideo.pause();
                    clearInterval(that.durationTimer);
                    if (window.needRecoRecordCourse) {
                        WebRTC.pauseRecordVideo();
                    }

                    if (window.needFfmpegRecordCourse && that.isFfmpegRecording) {
                        putaoWS.stopRecordScreen();
                        that.isFfmpegRecording = false;
                    }
                }
            }
        });
    }

    handleGoBack() {
        const that = this;
        that.setState({
            isBack: true,
        });
    }

    exitLesson() {
        const that = this;
        const { curPage, totalPage } = this.state;
        clearInterval(that.durationTimer);
        clearInterval(that.videoCartonTimer);
        if (window.isDev) {
            window.close();
        } else {
            // that.setLocalStorage();

            WebRTC.getAuthorization(false);

            that.setState({
                playingVideo: {
                    url: '',
                    isChild: false,
                    isPlaying: false, //是否正在播放中
                    nodeNum: -1, //当前视频所属的节点编号
                }
            }, () => {
                //后两页点返回了发finish
                if (window.medalOnOff && parseInt(curPage, 10) >= totalPage - 2 && totalPage > 3) {
                    // that.finishSendLessonStat(true); //改成进页面发
                    that.setState({ // 倒数第二页返回也弹课程小结
                        complete: true,
                        noNeedCommit: true, // 不需要评论框
                    });
                    if (window.isX5) {
                        const teachVideo = document.getElementById('teachVideo');
                        teachVideo && (teachVideo.style.display = 'none');
                    }
                } else {
                    //需要发统计
                    that.finishSituation(0);

                    if (that.isCTlesson || that.isUrlLesson || that.isCamp || that.needback) {
                        window.history.back();
                    } else {
                        if (that.project === "vipbingo") {
                            window.location.href = `https://www.aibingo.com.cn/bingo/vip_course/#/experience_camp?v=${window.pt_vid}`;
                        } else {
                            // window.location.href = `${window.location.pathname}${window.location.search}#/path?cid=${that.cid}${that.isTrialLesson ? "&type=trial_lesson" : ""}`;
                            window.location.href = `${window.publicUrl}?v=${window.pt_vid}#/path?cid=${that.cid}${that.isTrialLesson ? "&type=trial_lesson" : ""}`;

                        }
                    }
                }
            });

            if (window.needFfmpegRecordCourse && that.isFfmpegRecording) {
                putaoWS.stopRecordScreen({ "end": 1 });
                that.isFfmpegRecording = false;
            }
        }
    }

    //取消返回，继续学习
    continueLesson() {
        this.setState({
            isBack: false,
        });
    }

    //从头开始，不走缓存
    restartLesson() {
        const that = this;
        that.setState({
            localStorageInfo: null,
        }, () => {
            window.startTime = parseInt(new Date().getTime() / 1000, 10);
            that.getCourseData(() => {
                that.startWork(true);
                window.localStorage.removeItem('exitLesson-' + Utils.getHashQueryString('cid'));
            });
        });
    }

    //继续学习，走缓存
    continueLocalLesson() {
        const that = this;
        const { curPage, localStorageInfo } = this.state;
        if (
            (curPage < 1 || (window.isDev && that.cid)) &&
            localStorageInfo &&
            localStorageInfo.curPage &&
            localStorageInfo.currStarCount > -1 &&
            localStorageInfo.currSubjectCount > -1 &&
            localStorageInfo.startTime
        ) {
            that.setState({
                hideDialog: true
            }, () => {
                window.startTime = localStorageInfo.startTime || parseInt(new Date().getTime() / 1000, 10);
                that.getCourseData(() => {
                    that.setState({
                        currStarCount: localStorageInfo.currStarCount,
                        currSubjectCount: localStorageInfo.currSubjectCount,
                        curPage: localStorageInfo.curPage,
                    }, () => {
                        window.curPageToReport = localStorageInfo.curPage;
                        that.startWork(false);
                    });
                });
            });
        }
    }

    setLocalStorage() {
        const { curPage, totalPage, currStarCount, currSubjectCount } = this.state;
        if (curPage > 0 && curPage < totalPage - 2) {
            window.localStorage.setItem(
                'exitLesson-' + Utils.getHashQueryString('cid'),
                JSON.stringify({
                    curPage: curPage,
                    currStarCount: currStarCount,
                    currSubjectCount: currSubjectCount,
                    startTime: window.startTime,
                    duration: this.duration,
                })
            );
        }
    }

    //发送课程开始统计
    startSendLessonStat() {
        const that = this;
        Utils.sendStatRequest('/lesson/start', {
            putaoid: that.putaoid,
            token: decodeURIComponent(that.token),
            cid: that.cid,
            starttime: window.startTime,
            from: 'pc',
        });
    }

    //发送课程完成统计，正常学习上完发，假如在最后两页点击返回(flag=true)，也发
    finishSendLessonStat(notLastPage) {
        const that = this;
        window.localStorage.removeItem('exitLesson-' + Utils.getHashQueryString('cid'));
        window.localStorage.setItem('isFatherLessonEnd', true);
        Utils.sendStatRequest(notLastPage ? '/lesson/gen_report' : '/lesson/finish', {
            putaoid: that.putaoid, //
            token: decodeURIComponent(that.token),
            cid: that.cid, //
            starttime: window.startTime, //
            stars: that.state.currStarCount,
            from: 'pc',
            useReplay: 1,
            version: that.version,
            integrals: window.integrals,
        });

        that.finishSituation(1);

        if (window.needFfmpegRecordCourse && that.isFfmpegRecording) {
            putaoWS.stopRecordScreen({ "end": 1 });
            that.isFfmpegRecording = false;
        }
    }

    // 完课统计
    finishSituation(isFinish) {
        const that = this;
        //需要发统计
        let params = {
            putaoid: that.putaoid,
            token: decodeURIComponent(that.token),
            cid: that.cid,
            beginTime: window.beginTime,
            starttime: window.startTime,
            action: 'end',
            device: Utils.getDevice(),
            duration: that.duration || parseInt(new Date().getTime() / 1000, 10) - window.beginTime,
            isFinished: isFinish,
            score: 0,
            stars: that.state.currStarCount,
            from: 'pc',
            useReplay: 1,
        };
        if (isFinish) {
            params.lastPage = parseInt(that.state.curPage, 10) + 1; // 标明退出时所在的页码
        }
        Utils.sendStatRequest('/lesson/situation2', params);
    }

    render() {
        const that = this;
        const {
            hasDevices,
            hasResult,
            currStarCount,
            currSubjectCount,
            totalPage,
            curPage,
            isPause,
            pauseButton,
            expandCourse,
            showDeviceTips,
            toCenter,
            showPageNodes,
            showChildPageNodes,
            playingVideo,
            curRunChildNodeParent,
            complete,
            isBack,
            localStorageInfo,
            doneTryData,
            isToCocoOrPc,
            showNoNetWorkDialog,
            noNeedCommit,
            hideDialog,
            showDeniedRecordTips,
        } = this.state;
        let courseClass = 'content';
        if (expandCourse) {
            courseClass = 'content fullScreen';
        } else if (toCenter === 1) {
            courseClass = 'content toCenter';
        } else if (toCenter === 2) {
            courseClass = 'content toCourse';
        } else if (playingVideo && playingVideo.url) {
            courseClass = 'content';
        }

        let dialogTxt = '练一练';
        let dialogUrl = that.homeworkurl || `${HOMEWORK}&cid=${that.cid}&putaoid=${this.putaoid}&token=${this.token}`;
        if (that.project === "vipbingo") {
            dialogUrl = that.homeworkurl || `/bingo/onlinepages/course_h5/?v=${Math.floor(Math.random() * 1000)}&from=pc&cid=${that.cid}&putaoid=${that.putaoid}&token=${that.token}${that.noHomework === 1 ? "&nohome=1" : ""}&page=vipbingo`;
        }
        let dialogIsBack = false;
        if (that.noHomework === 1 || !that.homeworkurl) {
            dialogTxt = '看报告';
            dialogUrl = '';
            dialogIsBack = true;
        } else if (that.isFatherLesson || that.isCTlesson || (that.isUrlLesson && that.isUrlLesson.indexOf('minor/readers') > -1) || that.isReaders) {
            dialogTxt = '重新学习';
            dialogUrl = window.location.href;
            dialogIsBack = true;
        } else if (that.needback === 1) {
            dialogUrl += '&needback=1';
            dialogIsBack = true;
        }

        return (
            <div>
                {/* <EncourageReport isBack={that.isCamp ? true : dialogIsBack} /> */}
                {showDeniedRecordTips ? (
                    <CommonDialog
                        title='权限申请'
                        text='检测到您禁用了“屏幕录制”权限，启用后可以记录和回放宝贝学习精彩瞬间~'
                        otherText={`请到 系统设置偏好-安全性与隐私-隐私-屏幕录制 中把“${that.project === "vipbingo" ? 'VIP外教' : '步步ABC'}”勾上即可`}
                        htmlText={`<label for="neverNotify" style="color:#CCC;font-size:12px;");"><input type="checkbox" id="neverNotify" />&nbsp;&nbsp;不再提醒</label>`}
                        htmlHanlder={() => {
                            let neverNotify = document.getElementById('neverNotify');
                            if (neverNotify) {
                                let checked = neverNotify.checked;
                                if (checked) {
                                    window.localStorage.setItem('sereenRecordneverNotify', '1');
                                } else {
                                    window.localStorage.removeItem('sereenRecordneverNotify');
                                }
                            }
                        }}
                        cancleText='返回'
                        sureText='继续学习'
                        sureHanlder={() => {
                            that.cocosOnUrl(false);
                        }}
                        cancleHandler={() => {
                            window.history.back();
                        }}
                    />
                ) : null}
                {showDeviceTips ? (
                    <CommonDialog
                        title='设备禁用提醒'
                        text='您有设备被禁止使用，为了宝贝能正常学习，请允许访问摄像头、麦克风。'
                        otherText='常见问题说明'
                        otherHref='https://download-1256571289.cos.ap-beijing.myqcloud.com/Documents/instructions.pdf'
                        cancleText='关闭'
                        sureText='设备检测'
                        sureHanlder={() => {
                            if (that.project === "vipbingo") {
                                window.location.href = `https://www.aibingo.com.cn/bingo/vip_course/?v=${window.pt_vid}#/device`;
                            } else {
                                window.location.href = `${window.location.pathname}${window.location.search}#/device`;
                            }
                        }}
                        cancleHandler={() => {
                            window.history.back();
                        }}
                    />
                ) : null}
                <div className='cursor-content' style={{ display: isToCocoOrPc ? 'block' : 'none' }}>
                    <div className='skyBg' />
                    {complete ? (
                        <CourseScoreDialog
                            cid={that.cid}
                            type={that.isTrialLesson ? 'trial_lesson' : ''}
                            text={dialogTxt}
                            url={dialogUrl}
                            isBack={that.isCamp ? true : dialogIsBack}
                            noHomework={that.noHomework || (that.homeworkurl ? 0 : 1)}
                            noNeedCommit={window.isDev ? true : noNeedCommit}
                        />
                    ) : null}

                    <div id='topTitle' className='title'>
                        <div className='return' onClick={() => that.handleGoBack()} />
                        {that.courseInfo ? (
                            <div className='unit'>
                                <span>{that.courseTitle}</span>
                            </div>
                        ) : null}
                        {
                            window.medalOnOff ?
                                <ul id='medalList' className='medal' />
                                :
                                <ul className='give-star'>
                                    <li className={currStarCount > 0 ? 'add-star' : ''} />
                                    <li className={currStarCount > 1 ? 'add-star' : ''} />
                                    <li className={currStarCount > 2 ? 'add-star' : ''} />
                                    <li className={currStarCount > 3 ? 'add-star' : ''} />
                                    <li className={currStarCount > 4 ? 'add-star' : ''} />
                                </ul>
                        }
                    </div>

                    <div id='cursor' className='course_teacher_exchange'>
                        {isBack && !complete ? (
                            <CommonDialog
                                title='确认退出'
                                text='课程还未结束，完成课程可领取神秘礼物哦。确定要退出吗？'
                                cancleText='退出'
                                cancleHandler={() => {
                                    that.exitLesson();
                                }}
                                sureText="继续学习"
                                sureHanlder={() => {
                                    that.continueLesson();
                                }}
                            />
                        ) : null}

                        {!showDeviceTips && !hideDialog && that.project !== "vipbingo" && (curPage < 1 || (window.isDev && that.cid)) &&
                            localStorageInfo &&
                            localStorageInfo.curPage &&
                            localStorageInfo.currStarCount > -1 &&
                            localStorageInfo.currSubjectCount > -1 &&
                            localStorageInfo.startTime ? (
                            <CommonDialog
                                title="学习提示"
                                text="系统检测到您上次中断了课程，是否继续学习？"
                                cancleText="从头开始"
                                cancleHandler={() => {
                                    that.restartLesson();
                                }}
                                sureText="继续学习"
                                sureHanlder={() => {
                                    that.continueLocalLesson();
                                }}
                            />
                        ) : null}

                        <div id='studyVideoContent' className='study_video'>
                            <video id='webcam' muted autoPlay />
                            {
                                window.medalOnOff ?
                                    <div id='integrals' className='integrals'><span id='integrals_num'>0</span><span id='integrals_add' /></div>
                                    : null
                            }

                            <div id='selectCameraIcon' className="change-icon hide" title="切换摄像头" />
                            <div id='selectUserVideo' className='hide'>
                                <div className='select' className='hide'>
                                    <label htmlFor='audioSource'>Audio source: </label>
                                    <select id='audioSource' />
                                </div>

                                <div className='select'>
                                    <label htmlFor='videoSource' className='hide'>Video source: </label>
                                    <select id='videoSource' />
                                </div>
                            </div>
                        </div>

                        <div id='teacherVideoContent' className='teacher-video'>
                            {playingVideo.nodeNum === 'TeacherTest_' ? (
                                <div
                                    id='teachVideo'
                                    style={{
                                        textAlign: 'center',
                                        marginTop: '20%',
                                        color: '#f00',
                                    }}
                                >
                                    {playingVideo.url || 'teacher'}
                                </div>
                            ) : (
                                <video
                                    id='teachVideo'
                                    src={playingVideo.url}
                                    // src="file:///Users/chechew/Documents/pt/course_app/page/tmp/level2/unit1/lesson4/1575343252/video/L17-2_s.mp4"
                                    style={isSafari || that.isCanvasLastVideoPic ? { display: 'block' } : { display: 'none' }} /*autoPlay*/
                                    onCanPlay={() => that.handleVideoPlay()}
                                    // onPlay={() => that.handleVideoPlay()}
                                    onEnded={() => that.handleVideoEnd(playingVideo.isChild)}
                                    onError={() => (playingVideo.url ? that.handleVideoError(playingVideo.url) : null)}
                                    webkit-playsinline='true'
                                    playsInline='true'
                                    x5-playsinline='true'
                                    x5-video-player-type='h5-page'
                                    autoPlay={isSafari ? 'true' : 'false'}
                                />
                            )}

                            {!(hasDevices && hasResult) ? <div id='teacherLodding' className='teacher-view' /> : null}

                            <canvas id='myCanvas' width='690' height='518' />
                            {/* <div id="videoTop" /> */}
                        </div>

                        <div id='playPauseBtn'>
                            {(isSafari || pauseButton) && hasResult ? (
                                <div className='play-pause' onClick={() => that.handlePlayPauseCourse()}>
                                    <div className={isPause ? 'course-play' : 'course-play hide'} />
                                    <div className={!isPause ? 'course-pause' : 'course-pause hide'} />
                                </div>
                            ) : null}
                        </div>

                        <div id='content' className={courseClass}>
                            <div id='content_course' className='course'>
                                {showPageNodes && showPageNodes.length ? (
                                    <Course
                                        showPageNodes={showPageNodes}
                                        currStarCount={currStarCount}
                                        currSubjectCount={currSubjectCount}
                                        doneTryData={doneTryData}
                                        videoEnd={() => that.handleVideoEnd()}
                                        childCallback={(returnScore, replaceData) => that.handleChildCallback(returnScore, replaceData)}
                                    />
                                ) : null}
                                {showChildPageNodes && showChildPageNodes.length
                                    ? showChildPageNodes.map((showChildPageNodesItem, index) => {
                                        return (
                                            <div key={index}>
                                                {showChildPageNodesItem && showChildPageNodesItem.length ? (
                                                    <Course
                                                        showPageNodes={showChildPageNodesItem}
                                                        curRunChildNodeParent={curRunChildNodeParent}
                                                        currStarCount={currStarCount}
                                                        currSubjectCount={currSubjectCount}
                                                        doneTryData={doneTryData}
                                                        videoEnd={() => that.handleVideoEnd(true)}
                                                        childCallback={(returnScore, replaceData) => that.handleChildCallback(returnScore, replaceData)}
                                                    />
                                                ) : null}
                                            </div>
                                        );
                                    })
                                    : null}

                                {totalPage > 0 ? (
                                    <div className='pagination'>
                                        {parseInt(curPage, 10) + 1} / {totalPage}
                                    </div>
                                ) : null}
                                <div id='playAnimation' className='hide'
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        zIndex: 998,
                                        width: '100%',
                                        height: '100%',
                                    }}
                                />
                                <audio id='playAudio' src='' autoPlay onEnded={() => that.handleVideoEnd(false, true)} />
                                <audio id='playAudioChild' src='' autoPlay onEnded={() => that.handleVideoEnd(true, true)} />
                                <audio id='sayName' preload='true' src='' />
                            </div>
                            {!(hasDevices && hasResult) && !window.isDev ?
                                that.project === "vipbingo" ?
                                    <div className="course-lodding"><div className="loading-vip-text" /></div>
                                    :
                                    <div className="course-lodding"><div className="loading-text" /></div>
                                : null}
                        </div>

                        <img id='myImg' alt='' src='' style={{ position: 'fixed', bottom: 0 }} />
                        <canvas style={{ display: 'none' }} />

                        <div className='hidden'>
                            <div className='micro no-network' />
                            <img alt='' src='https://webres.putaoabc.com/course/images/medal/medal-201_s80.png' />
                            <img alt='' src='https://webres.putaoabc.com/course/images/medal/medal-202_s80.png' />
                            <img alt='' src='https://webres.putaoabc.com/course/images/medal/medal-203_s80.png' />
                            <img alt='' src='https://webres.putaoabc.com/course/images/medal/medal-204_s80.png' />
                            <img alt='' src='https://webres.putaoabc.com/course/images/medal/medal-205_s80.png' />
                            <img alt='' src='https://webres.putaoabc.com/course/images/medal/medal-206_s80.png' />
                            <img alt='' src='https://webres.putaoabc.com/course/images/medal/medal_animate.png' />
                            <img alt='' src='https://webres.putaoabc.com/course/images/medal/medal_fly.png' />
                            {that.nextPageImgArr && that.nextPageImgArr.length
                                ? that.nextPageImgArr.map((imgSrc, index) => {
                                    return <img alt='' key={index} src={`${window.resourceUrl + imgSrc}`} />;
                                })
                                : null}
                        </div>

                        {/* <div id="audioTest" className="audioOpare hide--" style={{ "position": "fixed", "bottom": 0, "left": "30%" }}>
                            <audio src="" id="playOnAudio" style={{ "height": "30px" }} controls autoPlay></audio>
                            <input type="button" value="开始录音" onClick={() => that.startRecording()} />
                            <input type="button" value="获取录音" onClick={() => that.obtainRecord()} />
                            <input type="button" value="停止录音" onClick={() => that.stopRecord()} />
                            <input type="button" value="播放录音" onClick={() => that.playRecord()} />
                            <input type="file" id="fileInput" />
                        </div> */}
                    </div>
                    {showNoNetWorkDialog ? (
                        <div className='dialog' style={{ background: 'rgba(0, 0, 0, 0.5)' }}>
                            <div className='no-network'>
                                <h3>加载失败</h3>
                                <p>受神秘力量影响，视频加载失败了～您可以</p>
                                <ul>
                                    <li>·暂时退出，换个时间继续学习～</li>
                                    <li>·或检查网络后，点击重试</li>
                                </ul>
                                <div onClick={() => that.handleRetryLoad(true)} className='retry-btn'>
                                    立即重试
                                </div>
                                <div onClick={() => that.handleRetryLoad(false)} className='close-networkDialog' />
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }
}

export default On;



// WEBPACK FOOTER //
// ./src/route/On.js